<style type="text/css" scoped>
/* Legacy betting grid + tab utilities kept in use */
.btn-default.focus,.btn-default:focus{background:0 0!important}.tab-pane>.row{padding:0 12px}.ui-modal-mask{z-index:1040}.tab-content{padding-left:0;padding-bottom:0;padding-right:0}.tab-content .column,.tab-content .column-78{float:left;margin-bottom:5px;padding-left:2.5px;padding-right:2.5px}.tab-content .column{width:10%}.tab-content .column-78{width:20%}.fa-check-circle-o{position:absolute;left:15px;top:11px;bottom:0}.animated{transition:.5s}.btn-dark.btn-transparent.active{background-color:rgba(31,34,37,.1)!important;border:1px solid #1f2225!important;color:#1f2225!important}.bet-price{width:100px}.table-responsive{padding:0;margin:0}.modal-body{padding-left:15px;padding-right:15px}.btn-remove-box{position:absolute;top:10px;right:10px}.container-fluid{padding:0}@media only screen and (max-width:600px){.nav.nav-tabs.nav-justified li{float:left;width:10%}.tab-pane .column{width:10%!important}.nav.nav-tabs.nav-justified a,.tab-pane .btn{padding-left:0!important;padding-right:0!important}.tab-pane.tab-numbersets .btn{padding-left:15px!important;padding-right:15px!important}.navbar-form.navbar-right{margin-right:-15px}.navbar-form.navbar-right button{width:100%;margin-top:8px;display:block}.subtype-group .btn{white-space:inherit}}
</style>

<style type="text/css" scoped>
/* Main lotto utility layout */
.column-main-lotto{float:left;width:33.333%;margin-bottom:5px;padding-left:2.5px;padding-right:2.5px}.column-main-lotto.double-column{width:66.666%}.column-main-lotto.half-viewport{width:50%}.input-group-cart-item .input-group-addon{width:100%!important;padding-top:9px}.input-group-cart-item strong{letter-spacing:10px;padding-left:10px;font-size:18px}.row-current-number{padding:7px 12px;font-size:5vw;text-align:center}@media only screen and (max-width:768px){.navbar-mainlotto{padding:0}.navbar-mainlotto ul li:first-child{border-right:1px solid #e7eaec!important}.row-current-number{font-size:15vw}.navbar-mainlotto li{width:49%;display:inline-block}}
</style>

<style>
/* Element table row states */
.el-table .warning-row {
    background: #c4e3f3;
  }

  .el-table .success-row {
    background: #f2dede;
  }

  .overlimit-text {
    font-size: 18px;
    font-weight: 1000;
  }
</style>

<template>

<div class="wrapper wrapper-content bet-page-shell">
  <div class="container-fluid bet-page-container">
 
    <div class="bet-page-header-wrap">
      <div class="col-xs-12">
        <div class="ibox m-b-md bet-hero-card">

          <div class="ibox-title bet-hero-card__title">
            <div class="bet-hero-card__heading">
              <div class="bet-hero-card__crumb">
                <router-link :to="{name: 'lottery'}" class="bet-hero-card__crumb-link">แทงหวย</router-link>
                <span class="bet-hero-card__crumb-sep">/</span>
                <span>จับยี่กี รอบที่ {{ $route.params.round }}</span>
              </div>
              <h3 class="bet-hero-card__name">จับยี่กี รอบที่ {{ $route.params.round }}</h3>
            </div>
            <div class="clearfix"></div>
          </div>

          <div class="ibox-title" v-if="!resultIsHidden">
            <h5 class="m-r-sm text-center text-danger" style="float: left">เลขออกแล้ว</h5>

            <vue-countdown-timer
              @start_callback="startCallBack(start_time)"
              @end_callback="endBetTime('close_bet_time ended')"
              :start-time="start_time"
              :end-time="close_bet_time"
              :interval="1000">
              <template slot="countdown" slot-scope="scope">
                <h5 class="m-r-sm text-center" style="float: right">ปิดรับอีก {{scope.props.hours}}:{{scope.props.minutes}}:{{scope.props.seconds}}</h5>
              </template>
              <template slot="end-text" slot-scope="scope">
                <vue-countdown-timer
                  :start-time="close_shoot_time"
                  :end-time="end_process_time"
                  :interval="1000">
                  <template slot="countdown" slot-scope="scope">
                    <h5 class="text-center text-danger" style="float: right"> อยู่ระหว่างการออกผล...</h5>
                  </template>
                  <template slot="end-text" slot-scope="scope">
                    <h5 class="text-center text-danger" style="float: right"> ปิดรับผล</h5>
                  </template>
                </vue-countdown-timer>
              </template>
            </vue-countdown-timer>

            <div class="clearfix"></div>
          </div>

          <div class="ibox-title" v-if="nextround">
            <h5 class="m-r-sm text-center">
              <a :href="`/yeekee/${nextround}`" class="text-primary-new"><i class="fa fa-share"></i> แทงรอบถัดไป ( รอบที่ {{ nextround }} ) </a>
            </h5>
            <div class="clearfix"></div>
          </div>

          <div class="ibox-content no-padding bet-hero-card__content">
            <nav class="navbar navbar-default nav-slug bet-slug-nav">

              <vue-countdown-timer
                @end_callback="endBetTime('close_bet_time ended')"
                :start-time="start_time"
                :end-time="close_bet_time"
                :interval="1000">
                <template slot="countdown" slot-scope="scope">
                  <div class="collapse navbar-collapse in no-borders">
                    <ul class="nav navbar-nav bet-slug-nav__list">
                      <li class="text-center mobile-full-width" ref="rulebox" v-bind:class="{ 'active': !ruleIsHidden }" v-on:click="hiddenMethod('rule', $event)">
                        <a href="#box-rules" class="btn-bet-info animated">กติกาจับยี่กี รอบที่ {{ $route.params.round }}</a>
                      </li>
                      <li class="text-center" ref="shoottablebox" v-bind:class="{ 'active': !shootTableIsHidden }" v-on:click="hiddenMethod('shootTable', $event)">
                        <a href="#box-shoot-table" class="btn-bet-info animated">ยิงเลข</a>
                      </li>
                      <li class="text-center has-mobile-border" ref="upbox" v-bind:class="{ 'active': !upIsHidden }" v-on:click="hiddenMethod('threetop', $event)">
                        <a href="#" class="btn-bet-info animated">สามตัว</a>
                      </li>
                      <li class="text-center" ref="downbox" v-bind:class="{ 'active': !downIsHidden }" v-on:click="hiddenMethod('twodown', $event)">
                        <a href="#" class="btn-bet-info animated">สองตัว</a>
                      </li>
                      <li class="text-center has-mobile-border" ref="runningbox" v-bind:class="{ 'active': !runningIsHidden }" v-on:click="hiddenMethod('running', $event)">
                        <a href="#" class="btn-bet-info animated">เลขวิ่ง</a>
                      </li>
                      <li class="text-center mobile-full-width">
                        <a href="/yeekee#number-sets-modal" data-toggle="modal" class="btn-bet-info" @click="loadUserNumber">เลขชุด / ดึงโพย</a>
                      </li>
                    </ul>
                  </div>
                </template>

                <template slot="end-text" slot-scope="scope">
                  <vue-countdown-timer
                    :start-time="start_time"
                    :end-time="close_shoot_time"
                    :interval="1000">
                    <template slot="countdown" slot-scope="scope">
                      <div class="collapse navbar-collapse in no-borders">
                        <ul class="nav navbar-nav bet-slug-nav__list">
                          <li class="text-center" ref="shoottablebox" v-bind:class="{ 'active': !shootTableIsHidden }" v-on:click="hiddenMethod('shootTable', $event)">
                            <a href="#box-shoot-table" class="btn-bet-info animated">ยิงเลข</a>
                          </li>
                        </ul>
                      </div>
                    </template>

                    <template slot="end-text" slot-scope="scope">
                      <div class="collapse navbar-collapse in no-borders">
                        <ul class="nav navbar-nav bet-slug-nav__list">
                          <li class="text-center mobile-full-width" ref="resultbox" v-bind:class="{ 'active': !resultIsHidden }" v-on:click="hiddenMethod('result', $event)">
                            <a href="#box-result" class="btn-bet-info animated">ผลรางวัล</a>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </vue-countdown-timer>
                </template>
              </vue-countdown-timer>

            </nav>
          </div>
        </div>
      </div>
    </div>

<div id="box-result" ref="boxresult" v-show="!resultIsHidden" style="position: relative;">
  <div class="col-xs-12">
    <div class="ibox m-b-md bet-section-card">
      <div class="ibox-content p-xs">

        <vue-countdown-timer
          @end_callback="endProcessTime('end_process_time ended')"
          :start-time="close_shoot_time"
          :end-time="end_process_time"
          :interval="1000">
            <template slot="countdown" slot-scope="scope">
              <div class="ibox m-b-md bet-section-card">
                <h3 class="text-primary-new text-center">อยู่ระหว่างการออกผล</h3>
                <div class="text-center">
                  <i class="fa fa-spinner fa-pulse fa-3x" style="color: #b42121;"></i>
                </div>
              </div>
            </template>
            <template slot="end-text" slot-scope="scope">

<div class="ibox m-b-md bet-result-shell" v-if="calculateLottoResult">

    <div class="bet-result-head text-center">
      <h2 class="bet-result-head__title">จับยี่กี รอบที่ {{ $route.params.round }}</h2>
      <h3 class="bet-result-head__subtitle">ปิดรับการทายผลตัวเลขออกรางวัล</h3>
    </div>

    <div class="bet-result-grid bet-result-grid--two">
      <div class="bet-result-grid__item">
        <div class="bet-result-stat-card bet-result-stat-card--compact text-center">
          <h3>ผลรวมยิงเลข</h3>
          <h1 class="bet-result-stat-card__value">
            <span class="text-navy">{{ yeekeeSumTotal }}</span>
          </h1>
        </div>
      </div>

      <div class="bet-result-grid__item">
        <div class="bet-result-stat-card bet-result-stat-card--compact text-center">
          <h3>เลขแถวที่ 16</h3>
          <h1 class="bet-result-stat-card__value">
            <span class="text-navy">{{ lotto_result.sixteen_number }}</span>
          </h1>
        </div>
      </div>
    </div>

    <div class="bet-result-grid bet-result-grid--two">
      <div class="bet-result-grid__item">
        <div class="bet-result-stat-card bet-result-stat-card--name text-center">
          <h3>สมาชิกยิงเลขได้ลำดับที่ 1</h3>
          <h1 class="bet-result-stat-card__value bet-result-stat-card__value--name text-info">
            {{ lotto_result.first_user }}
          </h1>
        </div>
      </div>

      <div class="bet-result-grid__item">
        <div class="bet-result-stat-card bet-result-stat-card--name text-center">
          <h3>สมาชิกยิงเลขได้ลำดับที่ 16</h3>
          <h1 class="bet-result-stat-card__value bet-result-stat-card__value--name text-danger">
            {{ lotto_result.sixteen_user }}
          </h1>
        </div>
      </div>
    </div>

    <div class="bet-result-grid bet-result-grid--three">
      <div class="bet-result-grid__item">
        <div class="bet-result-stat-card text-center">
          <h3>ผลรางวัล</h3>
          <h1 class="bet-result-stat-card__value bet-result-stat-card__value--mix">
            <span>{{ lotto_result.head_number }}</span><span class="text-success">{{ lotto_result.two_number }}</span><span class="text-danger">{{ lotto_result.three_number }}</span>
          </h1>
        </div>
      </div>

      <div class="bet-result-grid__item">
        <div class="bet-result-stat-card text-center">
          <h3>สามตัวบน</h3>
          <h1 class="bet-result-stat-card__value text-danger">{{ lotto_result.threetop }}</h1>
        </div>
      </div>

      <div class="bet-result-grid__item">
        <div class="bet-result-stat-card text-center">
          <h3>สองตัวล่าง</h3>
          <h1 class="bet-result-stat-card__value text-success">{{ lotto_result.twodown }}</h1>
        </div>
      </div>
    </div>

    <div class="row bet-result-row">
      <div class="col-md-10 col-md-offset-1">
        <div class="bet-table-shell">

          <data-tables-server 
            :data="yeekeeTableData" 
            :total="yeekeeTableTotal" 
            @query-change="loadYeekeeTable" 
            :table-props="tableResultProps" 
            :pagination-props="{ pageSizes: [20, 50, 100] }"
          >
                  <el-table-column type="index" label="ลำดับ" width="80">
                  </el-table-column>
                  <el-table-column prop="number" label="เลข" width="80">
                      <template slot-scope="scope">
                        <div v-html="formatRewardNumber(scope.row.get_reward, scope.row.number, scope.$index)"></div>
                      </template>
                  </el-table-column>
                  <el-table-column prop="name" label="สมาชิก" width="auto">
                      <template slot-scope="scope">
                        <div v-html="formatRewardName(scope.row.get_reward, scope.row.name, scope.$index)"></div>
                      </template>
                  </el-table-column>
                  <el-table-column prop="date_time" label="เวลาส่ง" width="200">
                      <template slot-scope="scope">
                        {{ formatDate(scope.row.created_at) }}
                      </template>
                  </el-table-column>

                </data-tables-server>

              </div>
            </div>
          </div>
        </div>

            </template>
        </vue-countdown-timer>


      </div>
    </div>
  </div>
</div>


<div id="box-rules" ref="boxrule" v-show="!ruleIsHidden" style="position: relative;">
  <div class="col-xs-12">
    <div class="ibox m-b-md bet-section-card">
      <div class="ibox-content p-xs">

<div class="ibox bet-section-card">
  <strong><i class="fa fa-star"></i> กติกาการเล่น หวยยี่กี <i class="fa fa-star"></i></strong>
  <br>
  <ul style="padding-left:15px">
    <li>ระบบเปิดรับแทงวันละ 88 รอบ ออกผลรางวัลทุก 15 นาที</li>
    <li>รอบแรกเริ่มเวลา 06:00 น. (เริ่มทายผลได้ตั้งแต่ 05:00 น. ทายผลล่วงหน้าได้ทุกรอบ)</li>
    <li>ปิดรับแทงรอบสุดท้าย เวลา 03:45 น.</li>
    <li>สามารถส่งตัวเลขได้ฟรีไม่จำกัดจำนวนครั้งด้วยกติกาที่ชัดเจนและตรวจสอบได้</li>
    <li>สมาชิกที่ยิงเลขได้ ลำดับที่ 16 จะได้รับเครดิตฟรี 400 บาท และ ลำดับ 1 ฟรี 200 บาท แต่จะต้องมียอดเดิมพันรอบนั้นขั้นต่ำ 100 บาทขึ้นไป</li>
    <li>เลขวิ่งบน รับทายผล 3 ตัวบนเหมือนหวยรัฐบาล</li>
    <li>หากเลขที่สมาชิกร่วมทายผล มีไม่ถึง 20 ลำดับ ไม่ว่ากรณีใดก็ตาม ทางระบบจะทำการคืนโพยและเงินที่แทงเข้ามาในรอบนั้นทันที</li>
  </ul>
  <br>
  <strong><i class="fa fa-star"></i> การออกผลรางวัล <i class="fa fa-star"></i></strong>
  <br>
  <ul style="padding-left:15px">
    <li>(การออกผลรางวัล คิดจาก ผลรางวัลที่สมาชิกทุกท่านส่งตัวเลขจำนวน 5 หลัก [12345] จากนั้นทีมงานจะนำตัวเลขที่สมาชิกส่งเข้ามาทั้งหมดในรอบนั้น มารวมกัน แล้วเอาผลรวมที่ได้นำไปลบกับเลข ลำดับที่ 16 ของรอบนั้น และนำผลที่ได้มาเป็นผลออกรางวัล)</li>
  </ul>

  <br>
  <strong><i class="fa fa-star"></i> ตัวอย่างการออกผลรางวัล <i class="fa fa-star"></i></strong>
  <br>
  <ul style="padding-left:15px">
  <li>ผลรวมการยิงเลขทั้งหมดได้  <strong class="text-navy">1234567890 – [45967 ตัวอย่างลำดับที่ 16] = 1234521923 </strong> (ผลหลังจากลบลำดับที่ 16)</li>
  <li>ผลรวม 3 ตัวท้าย จะถูกนำมาออกผลรางวัลเป็นเลข 3 ตัวบนของหวยยี่กี่รอบนั้นผลรวมหลักพันและหลักหมื่นจะถูกนำมาออกผลรางวัลเป็นเลข 2 ตัวล่าง ของหวยยี่กีรอบนั้น</li>
  <li>ตามตัวอย่างผลรวมหลังลบลำดับที่ 16 ได้ = <strong class="text-navy">12345<strong class="text-navy"><span style="color:blue">[21]</span></strong><span style="color:red">[923] </span></strong> = เลขที่ออก 3 ตัวบนคือ = <strong class="text-navy"><span style="color:red">[923] </span></strong> เลขที่ออก 2 ตัวล่างคือ = <strong class="text-navy"><span style="color:blue">[21]</span> </strong></li>
   </ul>

  <strong><i class="fa fa-star"></i> โบนัสพิเศษ <i class="fa fa-star"></i></strong>
  <br>
  <ol style="padding-left:15px;margin-bottom:0">
  <li>สมาชิกที่ยิงเลขได้ลำดับที่ 1 จะได้รับเครดิต ฟรี <strong class="text-navy">200</strong> บาท</li>
  <li>สมาชิกที่ยิงเลขได้ลำดับที่ 16 จะได้รับเครดิต ฟรี <strong class="text-navy">400</strong> บาท</li>
  </ol>
  <strong class="text-danger">หมายเหตุ</strong> ต้องมียอดเดิมพันรอบนั้นๆ ขั้นต่ำ <strong class="text-danger">100</strong> บาทขึ้นไปถึงจะได้รับโบนัสพิเศษ
  <br>

  <br>
  <strong><i class="fa fa-star"></i> ขั้นตอนการออกผลรางวัล <i class="fa fa-star"></i></strong>
  <br>
  <ol style="padding-left:15px;margin-bottom:0">
  <li>หลังจากหวยยี่กีปิดรับแทงแต่ละรอบ ระบบยิงเลขจะเปิดให้ยิงอีก 2 นาที หลังจากระบบยิงเลขปิด อีก 1 นาที ระบบจะทำการตรวจโพย โดยใช้เวลาการจ่ายเงินประมาณ 2-5 นาที</li>
  <li>ตัวอย่าง เช่น ยี่กีรอบที่ 1 ระบบปิดรับแทงเวลา 06:00 น. ระบบยิ่งเลขจะสามารถยิงเลขได้จนถึงเวลา 06:02 น ต่อไประบบจะทำการตรวจโพยในเวลา 06:03 น. และจะจ่ายเงินสมาชิกทั้งหมดเสร็จภายในเวลาไม่เกิน 06:08 น. </li>
  </ol>
  <br>
  <strong class="text-danger">หมายเหตุ</strong> โปรดตั้งเวลาของอุปกรณ์เข้าเล่นของท่านให้ตรงกับเวลาในเว็บ เพื่อที่ท่านจะได้ไม่สับสนกับเวลาปิดรับ เวลาที่แสดงผลการส่งตัวเลขจะใช้เวลาจากเชิฟเวอร์จริง
  <br><br>

  <strong><i class="fa fa-star"></i> อัตราการจ่ายหวยยี่กี {{site_name}} <i class="fa fa-star"></i></strong>
  <br>

  <ul style="padding-left:15px">
    <li>3 ตัวบน ราคาจ่าย {{ bettypeRateMapping.threetop }} บาท</li>
    <li>3 ตัวโต๊ด ราคาจ่าย {{ bettypeRateMapping.threemix }} บาท</li>
    <li>2 ตัวบน – ล่าง ราคา {{ bettypeRateMapping.twotop }} บาท</li>
    <li>เลขวิ่ง 3 ตัวบน ราคา {{ bettypeRateMapping.runtop }} บาท</li>
    <li>เลขวิ่ง 2 ตัวล่าง ราคา {{ bettypeRateMapping.rundown }} บาท</li>
  </ul>

  <strong class="text-danger">หมายเหตุ</strong> หากราคามีการเปลี่ยนแปลง จะแจ้งให้ทราบล่วงหน้าก่อนมีการเปลี่ยนแปลง 7 วัน
  <br><br>

  <span style="font-size: 16px; line-height: 25.7143px;">
    <span style="text-decoration: underline; font-weight: bold; color: rgb(255, 0, 0);">!!หากระบบล่มหรือขัดข้อง ระหว่างก่อนปิดการร่วมส่งทายผลตัวเลขออกรางวัลจนเป็นสาเหตุทำให้สมาชิกไม่สามารถเข้าใช้งานระบบได้ทีมงานจะทำการตัดสินการออกรางวัลตามความเหมาะสม (การตัดสินขึ้นอยู่กับดุลพินิจของทีมงาน ทีมงานจะตัดสินด้วยความโปร่งใสและเป็นธรรมที่สุด)
      <span style="text-decoration: underline;"> ก่อนหมดเวลาร่วมส่งผลทายผลตัวเลขออกรางวัลที่ 1 นาทีระบบเกิดปัญหาข้อข้องไม่สามารถเข้าใช้งานได้ ทำให้ท่านไม่สามารถเข้าร่วมทายผลตัวเลขได้ กรณีนี้ทางทีมงานจะทำการยกเลิกและคืนเงินเครดิตในรอบนั้นทีนที ถึงแม้ว่าก่อนหน้านั้นจะมีสมาชิกยิงเข้ามามากกว่า 20 ลำดับก็ตาม
      </span>
    </span>
  </span>
</div>

      </div>
    </div>
  </div>
</div>




<div id="box-shoot-table" ref="boxshoottable" v-show="!shootTableIsHidden" style="position: relative;">
  <div class="col-xs-12">
    <div class="ibox m-b-md bet-section-card">
      <div class="ibox-content p-xs">

        <div class="bet-shoot-shell">
          <div class="row">
            <div class="col-xs-12">
              <div class="row">

                <div class="col-xs-12 col-sm-6">
                  <div class="bet-shoot-panel">
                    <div class="bet-shoot-panel__header">
                      <div class="bet-shoot-panel__eyebrow">ช่วงยิงเลข</div>
                      <h2 class="bet-shoot-panel__title">ปิดรับการทายผลตัวเลขออกรางวัล</h2>
                    </div>

                    <vue-countdown-timer
                      @start_callback="startCallBack(start_time)"
                      @end_callback="endShootTime('close_shoot_time ended')"
                      :start-time="start_time"
                      :end-time="close_shoot_time"
                      :interval="1000"
                      v-if="!shootTableIsHidden"
                      :key="countdownKey"
                    >
                      <template slot="countdown" slot-scope="scope">
                        <div class="bet-shoot-countdown">{{ scope.props.hours }} : {{ scope.props.minutes }} : {{ scope.props.seconds }}</div>

                        <div class="bet-shoot-sum-card">
                          <div class="bet-shoot-sum-card__label">ผลรวมยิงเลข</div>
                          <div class="bet-shoot-sum-card__value">{{ yeekeeSumTotal }}</div>
                        </div>

                        <div class="form-group has-success bet-shoot-form-group">
                          <input
                            autocomplete="off"
                            type="text"
                            ref="yknumber"
                            v-model="yknumber"
                            @keypress="onlyNumber"
                            placeholder="กรอกตัวเลข 5 หลัก"
                            maxlength="5"
                            class="form-control input-lg text-center text-primary bet-shoot-input"
                            data-vv-scope="__global__"
                            aria-required="true"
                            aria-invalid="false"
                          >
                          <h4 class="text-danger text-center m-t-xs" style="display: none;"></h4>
                        </div>

                        <div class="row bet-shoot-actions">
                          <div class="col-sm-6 col-xs-6">
                            <button type="submit" @click="randomNumber" class="btn btn-block btn-primary btn-lg bet-primary-action">
                              สุ่มเลข
                            </button>
                          </div>
                          <div class="col-sm-6 col-xs-6">
                            <button
                              type="submit"
                              @click.once="insertNumber"
                              class="btn btn-block btn-primary btn-lg btnYeekeeSubmit bet-primary-action"
                              :disabled="clickedInsertNumber"
                            >
                              {{ insertButtonValue }}
                            </button>
                          </div>
                        </div>
                      </template>

                      <template slot="end-text" slot-scope="scope">
                        <vue-countdown-timer
                          :start-time="close_shoot_time"
                          :end-time="end_process_time"
                          :interval="1000"
                        >
                          <template slot="countdown" slot-scope="scope">
                            <div class="bet-shoot-closed-state">อยู่ระหว่างการออกผล...</div>
                          </template>
                          <template slot="end-text" slot-scope="scope">
                            <div class="bet-shoot-closed-state">ปิดรอบ</div>
                          </template>
                        </vue-countdown-timer>
                      </template>
                    </vue-countdown-timer>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6">
                  <div class="bet-shoot-table-card">
                    <div class="bet-shoot-table-card__title">ตารางการยิงเลข</div>

                    <div class="table-responsive bet-table-shell">
                      <data-tables-server
                        :data="yeekeeTableData"
                        :total="yeekeeTableTotal"
                        @query-change="loadYeekeeTable"
                        :table-props="tableProps"
                        :pagination-props="{ pageSizes: [20, 50, 100] }"
                      >
                        <el-table-column type="index" label="ลำดับ" width="80">
                        </el-table-column>
                        <el-table-column prop="number" label="เลข" width="80">
                        </el-table-column>
                        <el-table-column prop="name" label="สมาชิก" width="auto">
                          <template slot-scope="scope">
                            <div v-html="formatYeekeeName(scope.row.name, scope.$index)"></div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="date_time" label="เวลาส่ง" width="200">
                          <template slot-scope="scope">
                            {{ formatDate(scope.row.created_at) }}
                          </template>
                        </el-table-column>
                      </data-tables-server>
                    </div>
                  </div>
                  <div class="clearfix m-b-md"></div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>









<div class="ibox bet-main-shell">
<div class="col-md-9 bet-main-column">



  <div id="box-numbers" ref="boxnumbers" class="ibox bet-section-card" v-show="!numberIsHidden" style="position: relative;">
    <div class="ibox-title">
      <h5>ปิดรับ  {{ formatDate(end_time) }}</h5>
      <div class="clearfix"></div>
      <form class="navbar-form navbar-right nav-search-permutation">
        <!-- <div class="form-group">
          <div class="input-group">
            <span id="basic-addon1" class="input-group-addon"><i class="fa fa-search"></i></span> 
            <input ref="searchnum" number="" type="number" placeholder="ค้นหาตัวเลข" class="form-control" @input="searchNumber" @change="searchNumber">
          </div>
        </div>  -->
        <button type="button" class="btn btn-default bet-soft-action-btn" @click="setPermutFlag"><i class="fa fa-fw fa-random"></i>กลับเลข</button>
      </form>
    </div>

    <div id="betselected" class="ibox-title bet-price-toolbar">
      <h5>เลือกราคาแทงขั้นต่ำ</h5>
      <div class="clearfix"></div>

      <div class="money-input bet-money-input">
        <div class="row">

          <label for="inlineFold" class="col-xs-6 col-md-9 line-55">
          </label> 

          <div class="col-xs-6 col-md-3">
            <!-- <span class="input-group">
              <input type="text" placeholder="" maxlength="5" class="form-control money" :value="formatMoney(customBetValue)" @change="setCustomBetValue" @keypress="onlyNumber" >
            </span> 
            <button class="visible-xs pull-right btn btn-secondary" @click="clearBetValue">เคลียร์</button> -->

            <div class="input-group">
              <input type="text" placeholder="" maxlength="5" class="form-control money" :value="formatMoney(customBetValue)" @change="setCustomBetValue" @keypress="onlyNumber" >
              <span class="input-group-btn">
                <button class="pull-right btn btn-secondary" @click="clearBetValue">เคลียร์</button>
              </span>
            </div>

          </div> 
          
          <div class="col-xs-12 col-md-9 money-chips bet-money-chips">
            <button ref="bet1" class="coin-chip coin-chip--1" @click="setBetValue(1, $event)">1</button>
            <button ref="bet5" class="coin-chip coin-chip--5" @click="setBetValue(5, $event)">5</button>
            <button ref="bet10" class="coin-chip coin-chip--10" @click="setBetValue(10, $event)">10</button>
            <button ref="bet50" class="coin-chip coin-chip--50" @click="setBetValue(50, $event)">50</button>
            <button ref="bet100" class="coin-chip coin-chip--100" @click="setBetValue(100, $event)">100</button>
            <button ref="bet500" class="coin-chip coin-chip--500" @click="setBetValue(500, $event)">500</button>
          </div>

          <!-- <div class="hidden-xs col-md-3">
            <button class="btn btn btn-secondary" @click="clearBetValue">เคลียร์</button>
          </div> -->

        </div>
      </div>

    </div>

    <div class="ibox-content">
      <div class="subtype-group">

        <div class="row" v-if="!upIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm no-margins " v-on:click="numClickMethod('threetop', $event)" v-bind:class="{ 'btn-primary': buttthreetopIsActive, 'btn-default': !buttthreetopIsActive }">
                    {{ bettypeTextMapping.threetop }}
                    ({{ bettypeRateMapping.threetop }})
                  </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm no-margins" v-on:click="numClickMethod('threemix', $event)" v-bind:class="{ 'btn-primary': buttthreemixIsActive, 'btn-default': !buttthreemixIsActive }">
                    {{ bettypeTextMapping.threemix }}
                    ({{ bettypeRateMapping.threemix }})
            </button>
          </div>
        </div> 
        
        <div class="row" v-if="!frontIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('threefront', $event)" v-bind:class="{ 'btn-primary': buttthreefrontIsActive, 'btn-default': !buttthreefrontIsActive }">
                    {{ bettypeTextMapping.threefront }}
                    ({{ bettypeRateMapping.threefront }})
            </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('threedown', $event)" v-bind:class="{ 'btn-primary': buttthreedownIsActive, 'btn-default': !buttthreedownIsActive }">
                    {{ bettypeTextMapping.threedown }}
                    ({{ bettypeRateMapping.threedown }})
            </button>
          </div>
        </div> 

        <div class="row" v-if="!downIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('twotop', $event)" v-bind:class="{ 'btn-primary': butttwotopIsActive, 'btn-default': !butttwotopIsActive }">
                    {{ bettypeTextMapping.twotop }}
                    ({{ bettypeRateMapping.twotop }})
            </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('twodown', $event)" v-bind:class="{ 'btn-primary': butttwodownIsActive, 'btn-default': !butttwodownIsActive }">
                    {{ bettypeTextMapping.twodown }}
                    ({{ bettypeRateMapping.twodown }})
            </button>
          </div>
        </div>

        <div class="row" v-if="!runningIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('runtop', $event)" v-bind:class="{ 'btn-primary': buttruntopIsActive, 'btn-default': !buttruntopIsActive }">
                    {{ bettypeTextMapping.runtop }}
                    ({{ bettypeRateMapping.runtop }})
            </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('rundown', $event)" v-bind:class="{ 'btn-primary': buttrundownIsActive, 'btn-default': !buttrundownIsActive }">
                    {{ bettypeTextMapping.rundown }}
                    ({{ bettypeRateMapping.rundown }})
            </button>
          </div>
        </div>

        <div class="row" v-if="!hilowIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('hibet', $event)" v-bind:class="{ 'btn-primary': butthibetIsActive, 'btn-default': !butthibetIsActive }">
              สูง
              (50)
            </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('lowbet', $event)" v-bind:class="{ 'btn-primary': buttlowbetIsActive, 'btn-default': !buttlowbetIsActive }">
              ต่ำ
              (50)
            </button>
          </div>
        </div>

        <div class="row" v-if="!evenoddIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('evenbet', $event)" v-bind:class="{ 'btn-primary': buttevenbetIsActive, 'btn-default': !buttevenbetIsActive }">
              คู่
              (50)
            </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('oddbet', $event)" v-bind:class="{ 'btn-primary': buttoddbetIsActive, 'btn-default': !buttoddbetIsActive }">
              คี่
              (50)
            </button>
          </div>
        </div>

      </div> 

 <div class="row m-t-md" id="boxup" ref="boxup" v-show="!upIsHidden">
    <div class="col-xs-12">
      <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div> 
      <div ref="numbertab" class="tabbable">
        <ul class="nav nav-tabs nav-justified">
          <li class="active"><a href="/yeekee#uptab1" data-toggle="tab">000</a></li> 
          <li><a href="/yeekee#uptab2" data-toggle="tab">100</a></li> 
          <li><a href="/yeekee#uptab3" data-toggle="tab">200</a></li> 
          <li><a href="/yeekee#uptab4" data-toggle="tab">300</a></li> 
          <li><a href="/yeekee#uptab5" data-toggle="tab">400</a></li> 
          <li><a href="/yeekee#uptab6" data-toggle="tab">500</a></li> 
          <li><a href="/yeekee#uptab7" data-toggle="tab">600</a></li> 
          <li><a href="/yeekee#uptab8" data-toggle="tab">700</a></li> 
          <li><a href="/yeekee#uptab9" data-toggle="tab">800</a></li> 
          <li><a href="/yeekee#uptab10" data-toggle="tab">900</a></li>
        </ul> 
        <div class="tab-content m-t-md">
          <div id="uptab1" class="tab-pane animated fadeIn active in">
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(0, 99, 3)" :key="'up000-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color0" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab2" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(100, 199, 3)" :key="'up100-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color1" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab3" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(200, 299, 3)" :key="'up200-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color2" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab4" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(300, 399, 3)" :key="'up300-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color3" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab5" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(400, 499, 3)" :key="'up400-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color4" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab6" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(500, 599, 3)" :key="'up500-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color5" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab7" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(600, 699, 3)" :key="'up600-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color6" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab8" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(700, 799, 3)" :key="'up700-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color7" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab9" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(800, 899, 3)" :key="'up800-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color8" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab10" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(900, 999, 3)" :key="'up900-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color9" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div> 

  <div class="row m-t-md" id="boxfront" ref="boxfront" v-show="!frontIsHidden">
    <div class="col-xs-12">
      <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div> 
      <div ref="numbertab" class="tabbable">
        <ul class="nav nav-tabs nav-justified">
          <li class="active"><a href="/yeekee#fronttab1" data-toggle="tab">000</a></li> 
          <li><a href="/yeekee#fronttab2" data-toggle="tab">100</a></li> 
          <li><a href="/yeekee#fronttab3" data-toggle="tab">200</a></li> 
          <li><a href="/yeekee#fronttab4" data-toggle="tab">300</a></li> 
          <li><a href="/yeekee#fronttab5" data-toggle="tab">400</a></li> 
          <li><a href="/yeekee#fronttab6" data-toggle="tab">500</a></li> 
          <li><a href="/yeekee#fronttab7" data-toggle="tab">600</a></li> 
          <li><a href="/yeekee#fronttab8" data-toggle="tab">700</a></li> 
          <li><a href="/yeekee#fronttab9" data-toggle="tab">800</a></li> 
          <li><a href="/yeekee#fronttab10" data-toggle="tab">900</a></li>
        </ul> 
        <div class="tab-content m-t-md">
          <div id="fronttab1" class="tab-pane animated fadeIn active in">
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(0, 99, 3)" :key="'front000-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color0" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab2" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(100, 199, 3)" :key="'front100-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color1" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab3" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(200, 299, 3)" :key="'front200-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color2" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab4" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(300, 399, 3)" :key="'front300-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color3" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab5" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(400, 499, 3)" :key="'front400-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color4" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab6" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(500, 599, 3)" :key="'front500-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color5" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab7" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(600, 699, 3)" :key="'front600-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color6" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab8" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(700, 799, 3)" :key="'front700-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color7" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab9" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(800, 899, 3)" :key="'front800-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color8" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab10" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(900, 999, 3)" :key="'front900-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color9" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div> 
                            
<div class="row m-t-md" id="boxdown" ref="boxdown" v-show="!downIsHidden">
  <div class="col-xs-12">
    <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div>
    <hr class="m-t-none m-b-none"> 
      <div class="row">
        <div class="col-xs-12">
          <div class="down-inline-toolbar">
            <div class="down-inline-group">
              <strong class="down-inline-label">19 ประตู</strong>
              <div class="down-inline-buttons">
                <button type="button" @click="slide19goal(0, $event)" class="btn btn-default btn-sm">0</button>
                <button type="button" @click="slide19goal(1, $event)" class="btn btn-default btn-sm">1</button>
                <button type="button" @click="slide19goal(2, $event)" class="btn btn-default btn-sm">2</button>
                <button type="button" @click="slide19goal(3, $event)" class="btn btn-default btn-sm">3</button>
                <button type="button" @click="slide19goal(4, $event)" class="btn btn-default btn-sm">4</button>
                <button type="button" @click="slide19goal(5, $event)" class="btn btn-default btn-sm">5</button>
                <button type="button" @click="slide19goal(6, $event)" class="btn btn-default btn-sm">6</button>
                <button type="button" @click="slide19goal(7, $event)" class="btn btn-default btn-sm">7</button>
                <button type="button" @click="slide19goal(8, $event)" class="btn btn-default btn-sm">8</button>
                <button type="button" @click="slide19goal(9, $event)" class="btn btn-default btn-sm">9</button>
              </div>
            </div>

            <div class="down-inline-group">
              <strong class="down-inline-label">รูดหน้า</strong>
              <div class="down-inline-buttons">
                <button type="button" @click="slideFront(0, $event)" class="btn btn-default btn-sm">0</button>
                <button type="button" @click="slideFront(1, $event)" class="btn btn-default btn-sm">1</button>
                <button type="button" @click="slideFront(2, $event)" class="btn btn-default btn-sm">2</button>
                <button type="button" @click="slideFront(3, $event)" class="btn btn-default btn-sm">3</button>
                <button type="button" @click="slideFront(4, $event)" class="btn btn-default btn-sm">4</button>
                <button type="button" @click="slideFront(5, $event)" class="btn btn-default btn-sm">5</button>
                <button type="button" @click="slideFront(6, $event)" class="btn btn-default btn-sm">6</button>
                <button type="button" @click="slideFront(7, $event)" class="btn btn-default btn-sm">7</button>
                <button type="button" @click="slideFront(8, $event)" class="btn btn-default btn-sm">8</button>
                <button type="button" @click="slideFront(9, $event)" class="btn btn-default btn-sm">9</button>
              </div>
            </div>

            <div class="down-inline-group">
              <strong class="down-inline-label">รูดหลัง</strong>
              <div class="down-inline-buttons">
                <button type="button" @click="slideBack(0, $event)" class="btn btn-default btn-sm">0</button>
                <button type="button" @click="slideBack(1, $event)" class="btn btn-default btn-sm">1</button>
                <button type="button" @click="slideBack(2, $event)" class="btn btn-default btn-sm">2</button>
                <button type="button" @click="slideBack(3, $event)" class="btn btn-default btn-sm">3</button>
                <button type="button" @click="slideBack(4, $event)" class="btn btn-default btn-sm">4</button>
                <button type="button" @click="slideBack(5, $event)" class="btn btn-default btn-sm">5</button>
                <button type="button" @click="slideBack(6, $event)" class="btn btn-default btn-sm">6</button>
                <button type="button" @click="slideBack(7, $event)" class="btn btn-default btn-sm">7</button>
                <button type="button" @click="slideBack(8, $event)" class="btn btn-default btn-sm">8</button>
                <button type="button" @click="slideBack(9, $event)" class="btn btn-default btn-sm">9</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  <p class="m-t-md m-b-none text-center text-danger">
    <strong>โหมดการเล่น 19 ประตู, รูดหน้า และรูดหลัง ระบบการเล่นเลขที่ซ้ำ จะคิดเพียงเลขเดียว (หากต้องการแทงเลขซ้ำ ให้แทงโพยทีละครั้ง)</strong>
  </p> 
  <hr class="m-t-md m-b-md"> 
  <div class="tabbable">
    <div class="tab-content m-t-md">
      <div class="tab-pane animated fadeIn active in">
        <div class="row">

          <div class="column" v-for="(num, index) in createArray(0, 9, 2)" :key="'down0-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color0" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(10, 19, 2)" :key="'down1-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color1" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(20, 29, 2)" :key="'down2-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color2" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(30, 39, 2)" :key="'down3-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color3" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(40, 49, 2)" :key="'down4-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color4" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(50, 59, 2)" :key="'down5-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color5" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(60, 69, 2)" :key="'down6-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color6" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(70, 79, 2)" :key="'down7-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color7" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(80, 89, 2)" :key="'down8-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color8" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(90, 99, 2)" :key="'down9-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color9" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>

        </div>
      </div>
    </div>
  </div></div></div> 


<div class="row m-t-md" id="boxhilow" ref="boxhilow" v-show="!hilowIsHidden">
  <div class="col-xs-12">
    <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div>
    <hr class="m-t-none m-b-none">
    <p class="m-t-md m-b-none text-center text-danger"></p>
    <hr class="m-t-none m-b-none">
    <div class="tabbable">
      <div class="tab-content">
        <div class="row" style="padding: 0px 12px;">

          <div class="col-xs-4" v-for="(num, index) in hilowArray" :key="'hilow-' + index">
            <button type="button" :ref="'hilow_' + num" class="btn btn-block btn-default" @click="addCart( num, 'hilow', $event)"> {{ hilowMapping[num] }} </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="row m-t-md" id="boxevenodd" ref="boxevenodd" style="display: none">
  <div class="col-xs-12">
    <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div>
    <hr class="m-t-none m-b-none">
    <p class="m-t-md m-b-none text-center text-danger"></p>
    <hr class="m-t-none m-b-none">
    <div class="tabbable">
      <div class="tab-content">
        <div class="row" style="padding: 0px 12px;">

          <div class="col-xs-6" v-for="(num, index) in evenoddArray" :key="'evenodd-' + index">
            <button type="button" :ref="'evenodd_' + num" class="btn btn-block btn-default" @click="addCart( num, 'evenodd', $event)"> {{ evenoddMapping[num] }} </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


<div class="row m-t-md" id="boxrunning" ref="boxrunning" v-show="!runningIsHidden">
  <div class="col-xs-12">
    <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div> 
    <div class="tabbable">
      <div class="tab-content">
        <div class="row" style="padding: 0px 12px;">

          <div class="column-78" v-for="(num, index) in createArray(0, 9, 1)" :key="'running-' + index">
            <button type="button" :ref="'running_' + num" class="btn btn-block btn-default" @click="addCart( num, 'running', $event)"> {{ num }} </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="row m-t-md" >
  <div class="col-xs-12">
    <div class="col-xs-12 m-t-md" v-if="calculateBetSize > 0">
        <strong style="float: right" >จำนวนเงินทั้งหมด : {{ formatMoney(calculateBetValue) }} </strong>
    </div> 

    <div class="col-xs-6 col-md-3 m-t-md" style="float: right" v-if="calculateBetSize > 0">
      <button type="button" class="btn btn-danger btn-block" @click="deleteAllItems">ล้างข้อมูล</button>
    </div>
    <div class="col-xs-6 col-md-3 m-t-md" style="float: right" v-if="calculateBetSize > 0">
      <a href="/yeekee#modal-confirm-checkout" data-toggle="modal" class="btn btn-primary btn-block" :disabled="isDisabled" v-if="!isDisabled">แทงพนัน</a>
      <a href="" align="right" data-toggle="modal" class="btn btn-primary btn-block" :disabled="isDisabled" v-if="isDisabled">แทงพนัน</a>
    </div> 
  </div>
</div>

</div></div>
                </div> 

<div id="cart-item-list" class="col-md-3 bet-side-column" ref="cartitemlist" v-show="!numberIsHidden" style="position: relative;">
  <div class="ibox bet-cart-card">
    <div class="ibox-title bet-cart-card__title">
      <h5>รายการแทง</h5>
      <a href="/yeekee#number-sets-modal" data-toggle="modal" class="btn btn-warning pull-right btn-sm bet-cart-card__shortcut" @click="loadUserNumber">เลขชุด / ดึงโพย</a>
    </div>
    <div class="ibox-content bet-cart-card__content">

                    <div class="row">
                      <div class="col-xs-12 m-t-sm text-center" v-if="calculateBetSize">
                        <div class="input-group">
                          <input type="text" placeholder="" maxlength="5" class="form-control money" v-model="sameBetValue" @keypress="onlyNumber" >
                          <span class="input-group-btn">
                            <button class="pull-right btn btn-secondary bet-cart-inline-btn" @click="setAllSamePrice(sameBetValue)">เดิมพันราคาเท่ากัน</button>
                          </span>
                        </div>
                        <hr class="m-t-none m-b-md"> 
                      </div>
                    </div>
                    
                    <div class="row">
                      <div class="col-xs-12 m-t-sm text-center" v-if="calculateBetSize > 10">
                        <a href="#summarybottom" class="btn btn-primary btn-block" >ดูสรุปยอดแทงด้านล่าง</a>
                        <hr class="m-t-none m-b-md"> 
                      </div>
                      <div class="col-xs-12 m-t-sm text-center" v-if="calculateBetSize < 1">
                        <strong>ยังไม่มีรายการแทง</strong>
                      </div>

                      <!-- cart items -->

                      <div class="col-xs-12 m-b-xs" v-if="threetopCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.threetop }}</h4> 
                        <form class="form-inline" v-for="(item, index) in threetopCart" :key="'threetopCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber">
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="threemixCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.threemix }}</h4> 
                        <form class="form-inline" v-for="(item, index) in threemixCart" :key="'threemixCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="threefrontCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.threefront }}</h4> 
                        <form class="form-inline" v-for="(item, index) in threefrontCart" :key="'threefrontCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="threedownCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.threedown }}</h4> 
                        <form class="form-inline" v-for="(item, index) in threedownCart" :key="'threedownCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="twotopCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.twotop }}</h4> 
                        <form class="form-inline" v-for="(item, index) in twotopCart" :key="'twotopCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="twodownCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.twodown }}</h4> 
                        <form class="form-inline" v-for="(item, index) in twodownCart" :key="'twodownCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="runtopCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.runtop }}</h4> 
                        <form class="form-inline" v-for="(item, index) in runtopCart" :key="'runtopCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="rundownCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.rundown }}</h4> 
                        <form class="form-inline" v-for="(item, index) in rundownCart" :key="'rundownCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="hibetCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ hashhibet.text }}</h4> 
                        <form class="form-inline" v-for="(item, index) in hibetCart" :key="'hibetCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ hilowMapping[item.number] }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="lowbetCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ hashlowbet.text }}</h4> 
                        <form class="form-inline" v-for="(item, index) in lowbetCart" :key="'lowbetCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ hilowMapping[item.number] }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="evenbetCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ hashevenbet.text }}</h4> 
                        <form class="form-inline" v-for="(item, index) in evenbetCart" :key="'evenbetCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ evenoddMapping[item.number] }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="oddbetCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ hashoddbet.text }}</h4> 
                        <form class="form-inline" v-for="(item, index) in oddbetCart" :key="'oddbetCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ evenoddMapping[item.number] }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <!-- end cart items -->

                      <div class="col-xs-12 m-t-md" v-if="isDisabled">
                        <hr class="m-t-none m-b-md">
                        <span data-v-2eaffcc2="" style="background-color: rgb(255, 0, 0);font-size: 24px;color: #fff;">ไม่สามารถแทงเกินวงเงินได้ กรุณาตรวจสอบรายการแทง</span>
                      </div> 

                      <div class="col-xs-12 m-t-md" v-if="calculateBetSize > 0">
                        <hr class="m-t-none m-b-md"> 
                        <strong>จำนวนเงินทั้งหมด : {{ formatMoney(calculateBetValue) }} </strong>
                      </div> 

                      <div id="summarybottom" class="col-xs-6 col-md-6 m-t-md" v-if="calculateBetSize > 0">
                        <a href="/yeekee#modal-confirm-checkout" data-toggle="modal" class="btn btn-primary btn-block" :disabled="isDisabled" v-if="!isDisabled">แทงพนัน</a>
                        <a href="" data-toggle="modal" class="btn btn-primary btn-block" :disabled="isDisabled" v-if="isDisabled">แทงพนัน</a>
                      </div> 

                      <div class="col-xs-6 col-md-6 m-t-md" v-if="calculateBetSize > 0">
                        <button type="button" class="btn btn-danger btn-block" @click="deleteAllItems">ล้างข้อมูล</button>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="ibox float-e-margins">
                      <div class="ibox-title">
                        <h5>เงื่อนไขการแทง</h5>
                      </div> 
                      <div class="ibox-content">
                        <div class="row">
                          <div class="col-xs-12" v-if="!upIsHidden">
                          <h4 class="no-margins">
                          สามตัวบน
                          </h4>
                          แทงขั้นต่ำต่อครั้ง : 1 <br>
                          แทงสูงสุดต่อครั้ง : 500 <br>
                          แทงสูงสุดต่อเลข : 1,000 <br> 
                          <hr class="m-t-sm m-b-sm">
                        </div>
                        <div class="col-xs-12" v-if="!upIsHidden">
                          <h4 class="no-margins">
                            สามตัวโต๊ด
                          </h4>
                          แทงขั้นต่ำต่อครั้ง : 1 <br>
                          แทงสูงสุดต่อครั้ง : 500 <br>
                          แทงสูงสุดต่อเลข : 2,000 <br> 
                          <hr class="m-t-sm m-b-sm">
                        </div>
                        <div class="col-xs-12" v-if="!frontIsHidden">
                        <h4 class="no-margins">
                          สามตัวหน้า
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 1 <br>
                      แทงสูงสุดต่อครั้ง : 500 <br>
                      แทงสูงสุดต่อเลข : 2,500 <br> <hr class="m-t-sm m-b-sm"></div>
                      <div class="col-xs-12" v-if="!frontIsHidden">
                      <h4 class="no-margins">
                          สามตัวล่าง
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 1 <br>
                      แทงสูงสุดต่อครั้ง : 500 <br>
                      แทงสูงสุดต่อเลข : 2,500 <br> <hr class="m-t-sm m-b-sm"></div>
                      <div class="col-xs-12" v-if="!downIsHidden">
                      <h4 class="no-margins">
                          สองตัวบน
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 1 <br>
                      แทงสูงสุดต่อครั้ง : 1,000 <br>
                      แทงสูงสุดต่อเลข : 5,000 <br> <hr class="m-t-sm m-b-sm"></div>
                      <div class="col-xs-12" v-if="!downIsHidden">
                      <h4 class="no-margins">
                          สองตัวล่าง
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 1 <br>
                      แทงสูงสุดต่อครั้ง : 1,000 <br>
                      แทงสูงสุดต่อเลข : 5,000 <br> <hr class="m-t-sm m-b-sm"></div>
                      <div class="col-xs-12" v-if="!runningIsHidden">
                      <h4 class="no-margins">
                          วิ่งสามตัวท้ายบน
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>

                      <div class="col-xs-12" v-if="!runningIsHidden">
                      <h4 class="no-margins">
                          วิ่งสองตัวล่าง
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>


                      <div class="col-xs-12" v-if="!hilowIsHidden">
                      <h4 class="no-margins">
                          สูง
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>

                      <div class="col-xs-12" v-if="!hilowIsHidden">
                      <h4 class="no-margins">
                          ต่ำ
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>


                      <div class="col-xs-12" v-if="!evenoddIsHidden">
                      <h4 class="no-margins">คู่</h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>

                      <div class="col-xs-12" v-if="!evenoddIsHidden">
                      <h4 class="no-margins">คี่</h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>

                      </div></div></div></div></div>


<div id="number-sets-modal"  role="dialog" aria-hidden="true" class="modal inmodal">
  <div class="modal-dialog">
    <div class="modal-content animated fadeIn">
      <div class="modal-header">
        <button type="button" ref="closeUserNumber" data-dismiss="modal" class="close">
          <span aria-hidden="true">×</span>
          <span class="sr-only">Close</span>
        </button> 
        <h4 class="modal-title">เลขชุด / ดึงโพย</h4>
      </div>
      <div class="modal-body p-sm border-bottom">
        <div class="tabs-container">
          <ul class="nav nav-tabs">
            <li class="active">
              <a data-toggle="tab" href="#nbs-1"><i class="fa fa-list-ol"></i>เลือกเลขชุด</a>
            </li> 
            <li>
              <a data-toggle="tab" href="#nbs-2" @click="loadOrderHistory"><i class="fa fa-list"></i>ดึงโพย</a>
            </li>
          </ul> 
          <div class="tab-content">
            <div id="nbs-1" class="tab-pane tab-numbersets active">
              <div class="panel-body">
                <div class="text-center">
                <router-link :to="{name: 'numberset'}" class="btn btn-primary" target= '_blank'><i class='fa fa-cogs'></i> จัดการเลขชุด</router-link>
                <router-link :to="{name: 'addnumber'}" class="btn btn-primary" target= '_blank'><i class='fa fa-plus'></i> สร้างเลขชุด</router-link>
                <hr class="m-b-xs">
              </div>

              <data-tables :data="userNumberSet" :pagination-props="{ pageSizes: [10, 25, 50, 100] }" :table-props="numberTableProps">
                <el-table-column prop="name" label="ชื่อเลขชุด" width="auto" >
                </el-table-column>

                <el-table-column prop="created_at" label="วันที่สร้าง" width="auto">
                    <template slot-scope="scope">
                      <div>{{ formatDate(scope.row.created_at) }} </div>
                    </template>
                </el-table-column>

                <el-table-column prop="select" label="เลือก" width="auto" >
                  <template slot-scope="scope">
                    <a class="btn btn-primary btn-sm" @click="selectNumber(scope.row.id)">เลือก</a>
                  </template>
                </el-table-column>
              </data-tables>

          </div>
        </div>

        <div id="nbs-2" class="tab-pane tab-numbersets">
          <div class="panel-body">

              <data-tables :row-style="{height:'20px'}" :cell-style="{padding:'0px'}" style="font-size: 10px" :data="orderHistoryData" :pagination-props="{ pageSizes: [10, 25, 50, 100] }" :table-props="numberTableProps">
                <el-table-column prop="oh_ordnum" label="เลขที่รายการ" width="auto">
                    <template slot-scope="scope">
                      #{{scope.row.oh_ordnum}}
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="งวดที่" width="auto">
                </el-table-column>
                <el-table-column prop="created_at" label="วันที่ / เวลา" width="auto">
                    <template slot-scope="scope">
                      <div>{{ formatDate(scope.row.created_at) }} </div>
                    </template>
                </el-table-column>
                <el-table-column prop="edit" label="เลือก" width="80" >
                  <template slot-scope="scope">
                    <a class="btn btn-primary btn-sm" @click="selectOrder(scope.row.id)">เลือก</a>
                  </template>
                </el-table-column>
              </data-tables>

          </div>
        </div>

      </div>
    </div>
  </div>
</div></div></div>

<div id="modal-confirm-checkout"  role="dialog" aria-hidden="true" class="modal inmodal">
  <div class="modal-dialog">
    <div class="modal-content animated fadeIn">
      <div class="modal-header" style="padding-bottom: 15px;">
        <button type="button" data-dismiss="modal" class="close"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button> <h4 class="modal-title">ดูโพยอีกครั้งก่อนยืนยันการแทงพนัน</h4> <small class="font-bold">{{ round_data.description }}</small></div> 
<div class="text-center p-sm">
  <div class="row">
    <div class="col-xs-6">
      <!-- <button type="button"  data-dismiss="modal" @click="showCheckoutSuccess" class="btn btn-primary btn-block btn-lg"><i class="fa fa-check"></i> ส่งโพย</button> -->
      <button type="button" data-dismiss="modal" @click.once="createOrderhead" class="btn btn-primary btn-block btn-lg" :key="doubleClickKey"><i class="fa fa-check"></i> ส่งโพย</button>
    </div> 
    <div class="col-xs-6">
      <button type="button" data-dismiss="modal" class="btn btn-danger btn-block btn-lg">ยกเลิก</button>
    </div>
  </div>
</div> 


<!-- summarize item -->

<div class="col-xs-12 m-t-sm" v-if="threetopCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.threetop }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in threetopCart" :key="'threetop-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="threemixCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.threemix }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in threemixCart" :key="'threemix-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="threefrontCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.threefront }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in threefrontCart" :key="'threefront-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="threedownCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.threedown }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in threedownCart" :key="'threedown-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="twotopCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.twotop }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in twotopCart" :key="'twotop-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="twodownCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.twodown }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in twodownCart" :key="'twodown-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="runtopCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.runtop }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in runtopCart" :key="'runtop-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="rundownCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.rundown }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in rundownCart" :key="'rundown-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="hibetCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ hashhibet.text }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in hibetCart" :key="'hibet-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทง {{ hilowMapping[item.number] }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="lowbetCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ hashlowbet.text }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in lowbetCart" :key="'lowbet-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทง {{ hilowMapping[item.number] }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="evenbetCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ hashevenbet.text }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in evenbetCart" :key="'evenbet-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทง {{ evenoddMapping[item.number] }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="oddbetCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ hashoddbet.text }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in oddbetCart" :key="'oddbet-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทง {{ evenoddMapping[item.number] }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<!-- end summarize item -->

<div class="col-xs-12 text-right m-b-sm m-t-sm">
  <strong>รวม :</strong> <strong>{{ calculateBetValue }}</strong>
</div> 

<div class="p-sm border-top text-center">
  <div class="row">
    <div class="col-xs-6">
      <!-- <button type="button" data-dismiss="modal" @click="showCheckoutSuccess" class="btn btn-primary btn-block btn-lg"><i class="fa fa-check"></i> ส่งโพย</button> -->
      <button type="button" data-dismiss="modal" @click.once="createOrderhead" class="btn btn-primary btn-block btn-lg" :key="doubleClickKey"><i class="fa fa-check"></i> ส่งโพย</button>

    </div> 
    <div class="col-xs-6">
      <button type="button" data-dismiss="modal" class="btn btn-danger btn-block btn-lg">ยกเลิก</button>
    </div>
  </div>
</div>
</div></div></div>


<div id="modal-checkout-success" ref="modalcheckoutsuccess"  role="dialog" aria-hidden="true" class="modal inmodal" @click="closeOutsideModal">
  <div class="modal-dialog">
  <div class="modal-content animated fadeIn">
    <div class="modal-header">
      <h1><i class="fa fa-check text-navy" style="font-size: 60px;"></i></h1> 
      <h4 class="modal-title">ระบบได้ทำการส่งโพยของท่านเรียบร้อยแล้ว</h4>
    </div> 
    <div class="modal-body p-sm border-bottom">
      <h3 class="text-left">โพยเลขที่ #{{ orderNumber }}</h3>
      <h3 class="text-left m-b-none">{{ round_data.description }}</h3></div> 

      <div class="p-sm text-center">
        <div class="row">
          <div class="col-xs-6">
            <!-- <a type="button" href="/transaction" class="btn btn-primary btn-block btn-lg"><i class="fa fa-fw fa-list-ol"></i> ดูโพย</a> -->
            <button type="button" data-dismiss="modal" class="btn btn-primary btn-block btn-lg" @click="redirectTransaction"><i class="fa fa-fw fa-list-ol"></i> ดูโพย</button>
          </div> 
          <div class="col-xs-6">
            <button type="button" data-dismiss="modal" class="btn btn-primary btn-block btn-lg" @click="continueBet"><i class="fa fa-fw fa-sign-in"></i> แทงต่อ</button>
          </div>
        </div>
      </div> 

      <!-- summarize success items -->

      <div class="col-xs-12 m-t-sm" v-if="processItems['threetop'] && processItems['threetop'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.threetop }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['threetop']" :key="'threetop-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['threemix'] && processItems['threemix'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.threemix }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['threemix']" :key="'threemix-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['threefront'] && processItems['threefront'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.threefront }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['threefront']" :key="'threefront-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['threedown'] && processItems['threedown'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.threedown }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['threedown']" :key="'threedown-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['twotop'] && processItems['twotop'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.twotop }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['twotop']" :key="'twotop-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['twodown'] && processItems['twodown'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.twodown }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['twodown']" :key="'twodown-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['runtop'] && processItems['runtop'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.runtop }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['runtop']" :key="'runtop-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['rundown'] && processItems['rundown'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.rundown }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['rundown']" :key="'rundown-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div>


      <div class="col-xs-12 m-t-sm" v-if="processItems['hibet'] && processItems['hibet'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ hashhibet.text }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['hibet']" :key="'hibet-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทง {{ hilowMapping[item.number] }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['lowbet'] && processItems['lowbet'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ hashlowbet.text }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['lowbet']" :key="'lowbet-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทง {{ hilowMapping[item.number] }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 


      <div class="col-xs-12 m-t-sm" v-if="processItems['evenbet'] && processItems['evenbet'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ hashevenbet.text }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['evenbet']" :key="'evenbet-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทง {{ evenoddMapping[item.number] }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['oddbet'] && processItems['oddbet'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ hashoddbet.text }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['oddbet']" :key="'oddbet-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทง {{ evenoddMapping[item.number] }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 


      <!-- end of summarize success items -->

      <div class="col-xs-12 m-t-sm">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">รวม</h4> 
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(calculateBetValue) }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(totalSuccessResult) }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(totalFailResult) }}</h4>
      </div> 


      <div class="p-sm border-top text-center">
        <div class="row">
          <div class="col-xs-6">

            <!-- <router-link :to="{name: 'account'}" class="btn btn-primary btn-block btn-lg"><i class="fa fa-fw fa-list-ol"></i> ดูโพย</router-link> -->
            <button type="button" data-dismiss="modal" class="btn btn-primary btn-block btn-lg" @click="redirectTransaction"><i class="fa fa-fw fa-list-ol"></i> ดูโพย</button>
            <!-- <a type="button" href="/transaction" class="btn btn-primary btn-block btn-lg"><i class="fa fa-fw fa-list-ol"></i> ดูโพย</a> -->

          </div> 
          <div class="col-xs-6">
            <button type="button" data-dismiss="modal" class="btn btn-primary btn-block btn-lg" @click="continueBet"><i class="fa fa-fw fa-sign-in"></i> แทงต่อ</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div id="modal-button-confirm"  role="dialog" aria-hidden="true" class="modal inmodal" >
  <div style="width: 400px; margin: 30px auto;">
  <div class="modal-content animated fadeIn">
    <div class="modal-header">
      <button type="button" data-dismiss="modal" class="close">
        <span aria-hidden="true">×</span><span class="sr-only">Close</span>
      </button> 
      <h1><i class="fa fa-exclamation text-navy" style="font-size: 80px;"></i></h1> 
      <h4 class="modal-title">การกดแทงเลขที่เคยแทงแล้ว จะเป็นการยกเลิกการแทงเลขนั้นๆ, คุณต้องการยกเลิก ใช่ หรือ ไม่ใช่ ?</h4>
    </div> 

      <div class="p-sm text-center">
        <div class="row">
          <div class="col-xs-6">

            <button type="button" data-dismiss="modal" class="btn btn-primary" ><i class="fa fa-fw fa-check"></i> ใช่</button>
          </div> 
          <div class="col-xs-6">
            <button type="button" data-dismiss="modal" class="btn btn-primary btn-danger" ><i class="fa fa-fw fa-close"></i> ไม่ใช่</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>



<div style="display: none;">
<a href="#modal-checkout-success" data-toggle="modal" class="btn btn-primary btn-block" ref="clickCheckoutSuccess" ></a>
<a href="#modal-button-confirm" data-toggle="modal" class="btn btn-primary btn-block" ref="clickDeleteButton" ></a>
</div>

        </div>
      </div><!-- /#page-wrapper -->

</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

//yeekee type
const LOTTO_TYPE_ID = 4

export default {
    name: 'yeekee',
    data () {
        return {

            bettypeTextMapping: {
                threetop: 'สามตัวบน',
                threemix: 'สามตัวโต๊ด',
                twotop: 'สองตัวบน',
                twodown: 'สองตัวล่าง',
                runtop: 'วิ่งบน',
                rundown: 'วิ่งล่าง',
            },

            bettypeCodeMapping: {
                threetop: '4',
                threemix: '1',
                twotop: '6',
                twodown: '7',
                runtop: '8',
                rundown: '9',
            },

            bettypeRateMapping: {
                threetop: 950,
                threemix: 150,
                twotop: 95,
                twodown: 95,
                runtop: '3.20',
                rundown: '4.20',
            },

            bettypeDiscountMapping: {
                threetop: 0,
                threemix: 0,
                twotop: 0,
                twodown: 0,
                runtop: 0,
                rundown: 0,
            },

            hashthreetop: {
                text: 'สามตัวบน',
                rate: 950,
            },
            hashthreemix: {
                text: 'สามตัวโต๊ด',
                rate: 130,
            },
            hashthreefront: {
                text: 'สามตัวหน้า',
                rate: 400,
            },
            hashthreeback: {
                text: 'สามตัวหลัง',
                rate: 400,
            },
            hashthreedown: {
                text: 'สามตัวล่าง',
                rate: 400,
            },
            hashtwotop: {
                text: 'สองตัวบน',
                rate: 95,
            },
            hashtwodown: {
                text: 'สองตัวล่าง',
                rate: 95,
            },
            hashruntop: {
                text: 'วิ่งบน',
                rate: '3.20',
            },
            hashrundown: {
                text: 'วิ่งล่าง',
                rate: '4.20',
            },
            hashhibet: {
                text: 'สูง',
                rate: '50',
            },
            hashlowbet: {
                text: 'ต่ำ',
                rate: '50',
            },
            hashevenbet: {
                text: 'คู่',
                rate: '50',
            },
            hashoddbet: {
                text: 'คี่',
                rate: '50',
            },

            hilowMapping: {
                '55999': 'สามตัวบน',
                '55599': 'สองตัวบน',
                '55500': 'สองตัวล่าง',
            },
            evenoddMapping: {
                '55559': 'บน',
                '55550': 'ล่าง',
            },

            betvalue: 1,
            defaultBetvalue: 1,
            customBetValue: 1,
            sameBetValue: '',

            ruleIsHidden: false,
            shootTableIsHidden: true,
            numberIsHidden: true,
            upIsHidden: true,
            frontIsHidden: true,
            downIsHidden: true,
            runningIsHidden: true,
            hilowIsHidden: true,
            evenoddIsHidden: true,
            resultIsHidden: false,

            numIsDisable: true,
            overCredit: false,

            buttthreetopIsActive: false,
            buttthreemixIsActive: false,
            buttthreefrontIsActive: false,
            buttthreedownIsActive: false,
            butttwotopIsActive: false,
            butttwodownIsActive: false,
            buttruntopIsActive: false,
            buttrundownIsActive: false,
            butthibetIsActive: false,
            buttlowbetIsActive: false,
            buttevenbetIsActive: false,
            buttoddbetIsActive: false,

            permutFlag: false,

            betTypes: {},

            defaultCartTypes: [
                'threetopCart',
                'threemixCart',
                'threefrontCart',
                'threedownCart',
                'twotopCart',
                'twodownCart',
                'runtopCart',
                'rundownCart',
                'hibetCart',
                'lowbetCart',
                'evenbetCart',
                'oddbetCart',
            ],

            threetopCart: [],
            threemixCart: [],
            threefrontCart: [],
            threedownCart: [],
            twotopCart: [],
            twodownCart: [],
            runtopCart: [],
            rundownCart: [],
            hibetCart: [],
            lowbetCart: [],
            evenbetCart: [],
            oddbetCart: [],

            orderNumber: 0,
            userCredit: 0,

            defaultNumber: new Array(100),
            productList: [],

            //bet1Style: "background-color: #DCDCDC",
            bet1Style: '',
            bet5Style: '',
            bet25Style: '',
            bet100Style: '',
            bet500Style: '',

            totalSuccessResult: 0,
            totalFailResult: 0,

            totalBetValue: 0,
            totalDiscountResult: 0,
            totalSubValue: 0,

            hilowArray: [ '55999', '55599', '55500' ],
            evenoddArray: [ '55559', '55550' ],

            processItems: {},
            clickedInsertNumber: false,
            insert_timeout: null,
            countDown: 10,

            refresh_interval: null,
            countdownKey: 0,
            doubleClickKey: 0,
            site_name: '',

            yknumber: '',
            yeekeeTableData: [],
            yeekeeTableTotal: 0,
            yeekeeSumTotal: 0,
            tableProps: {
                border: true,
                stripe: false,
                defaultSort: {
                    prop: 'created_at',
                    order: 'descending'
                },
                rowClassName({row, rowIndex}) {
                    let row_class = ''
                    if (rowIndex == 0) {
                        row_class = 'warning-row'
                    }
                    else if (rowIndex == 15) {
                        row_class = 'success-row'
                    }
                    return row_class
                },
            },
            start_time: '',
            end_time: '',
            close_bet_time: '',
            close_shoot_time: '',
            end_process_time: '',
            round_data: {},
            lotto_result: {},
            tableResultProps: {
                border: true,
                stripe: false,
                defaultSort: {
                    prop: 'created_at',
                    order: 'descending'
                },
                rowClassName({row, rowIndex}) {
                    let row_class = ''
                    if (rowIndex == 0 && row.get_reward == 1) {
                        row_class = 'warning-row'
                    }
                    else if (rowIndex == 15 && row.get_reward == 1) {
                        row_class = 'success-row'
                    }
                    return row_class
                },
            },

            userNumberSet: [],
            numberTableProps: {
                border: true,
                stripe: false,
                defaultSort: {
                    prop: 'created_at',
                    order: 'descending'
                },
            },
            orderHistoryData: [],

            bettypeIdMapping: {
                4: 'threetop',
                1: 'threemix',
                // 2: 'threefront',
                // 3: 'threedown',
                // 5: 'threeback', //TODO: not implement yet
                6: 'twotop',
                7: 'twodown',
                8: 'runtop',
                9: 'rundown',
            },

            bettypeCartMapping: {
                4: 'up',
                1: 'up',
                6: 'down',
                7: 'down',
                8: 'running',
                9: 'running',
            },

            overLimitEnable: false,
            overLimitData: {},
            bettypeButtonClassMapping: {
                1: 'btn-danger',
                4: 'btn-harzard',
                6: 'btn-danger',
                7: 'btn-harzard',
                8: 'btn-danger',
                9: 'btn-harzard',
            },
            bettypeClassGroupMapping: {
                1: 4,
                4: 1,
                6: 7,
                7: 6,
                8: 9,
                9: 8,
            },
            orderBettype: {},
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            //orderhead: state => state.orderhead.orderhead,
            //ledger: state => state.ledger.ledger,
            //cartrule: state => state.cartrule.cartrule,
            //betlimit: state => state.betlimit.betlimit,
            round: state => state.round.round,

        }),
        nextround: function() {
            let round_id = this.$route.params.round
            let next_round = parseInt(round_id) + 1

            if ( next_round > 88 ) {
                // latest round
                next_round = 0
            }

            return next_round
        },
        calculateBetSize: function() {
            
            var size = 0
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                let cartsize = this.$data[carttext].length
                //console.log('cartsize:'+ carttext + ' : ' + cartsize)
                size = size + cartsize
            }
            //console.log('betSize:', size)
            return size

        },
        calculateBetValue: function() {
            var betvaluetot = 0

            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    betvaluetot = parseFloat(betvaluetot) + parseFloat(this.$data[carttext][j].betvalue)
                }
            }

            return betvaluetot.toFixed(2)
        },
        isDisabled() {
            var overcredit = false

            var betvaluetot = 0
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    betvaluetot = parseFloat(betvaluetot) + parseFloat(this.$data[carttext][j].betvalue)
                }
                
            }
            //console.log('isDisabled', betvaluetot, this.userCredit)
            if ( betvaluetot >  this.userCredit) {
                overcredit = true 
            }
            else {
                overcredit = false
            }
            return overcredit
        },
        insertButtonValue() {
            if ( this.clickedInsertNumber ) {
                return this.countDown
            }
            return 'เพิ่มเลข'
        },
        calculateLottoResult() {
            if ( moment().isAfter(this.end_process_time) ) {
                return true
            }
            return false
        },
        failClass() {
            if ( this.totalFailResult > 0 ) {
                return { 'overlimit-text': true }
            }
            return { 'overlimit-text': false }
        },

    },
    mounted () {
        this.site_name = process.env.VUE_APP_SITE
        this.loadSpecificRound()
    },
    created () {
        this.getStartTime()
        this.loadUserBalance()
        this.initWinRateAndDiscount()

        this.overLimitEnable = process.env.VUE_APP_OVERLIMIT_ENABLE
        this.loadOverLimitNumber()

        // refreh every 20 seconds
        this.refresh_interval = setInterval(() => this.forceRerender(), 20000)
    },
    updated () {
        //this.loadUserBalance()
    },
    methods: {
        forceRerender() {
            // รีเฟรช countdown เฉพาะตอนอยู่หน้า shoot table จริง ๆ
            // และยังไม่หมดช่วงยิงเลข
            if (!this.shootTableIsHidden && moment().isBefore(this.close_shoot_time)) {
                this.countdownKey += 1
            }
        },
        initWinRateAndDiscount() {
            //console.log('params', this.$route.params, LOTTO_TYPE_ID)
            const user_win_disc = this.user.winrateData
            let lottotype_id = LOTTO_TYPE_ID

            for (let k in this.bettypeRateMapping) {
                let bettype_id = this.bettypeCodeMapping[k]

                if ( user_win_disc[lottotype_id] && user_win_disc[lottotype_id][bettype_id] ) {
                    this.bettypeRateMapping[k] = user_win_disc[lottotype_id][bettype_id].pay_rate
                    this.bettypeDiscountMapping[k] = user_win_disc[lottotype_id][bettype_id].discount
                }
            }

        },

        async loadSpecificRound () {
            try {

                let round_id = this.$route.params.round

                const response = await this.$store.dispatch('round/getRoundYeekeeByRoundId', round_id)
                //console.log('async initial loadSpecificRound', response)

                let endTime = moment(response.expiration_date).format('HH.mm')
                let [ehh, emm] = endTime.split('.')

                let start_time = moment().hour(5).minute(0).second(0)

                //check current date

                if ( moment().isBefore(start_time) ) {
                    // current time is 00.01 - 04.59 < 05.00

                    let yesterday = moment().subtract(1, 'days')
                    this.end_time = moment(yesterday).hour(ehh).minute(emm).second(0)
                    this.close_bet_time = moment(this.end_time).subtract(1, 'seconds')
                    this.close_shoot_time = moment(this.close_bet_time).add(2, 'minutes') // 17.00
                    this.end_process_time = moment(this.close_shoot_time).add(90, 'seconds') // 18.30

                    if ( round_id > 73 ) {
                        //bet in today, cancel date is today
                        this.end_time = moment().hour(ehh).minute(emm).second(0)
                        this.close_bet_time = moment(this.end_time).subtract(1, 'seconds')
                        this.close_shoot_time = moment(this.close_bet_time).add(2, 'minutes')
                        this.end_process_time = moment(this.close_shoot_time).add(90, 'seconds')
                    }
                    else if ( round_id == 73 ) {
                        //bet in today, cancel date is today
                        this.end_time = moment().hour(0).minute(0).second(0)
                        this.close_bet_time = moment(this.end_time).subtract(1, 'seconds')
                        this.close_shoot_time = moment(this.close_bet_time).add(2, 'minutes')
                        this.end_process_time = moment(this.close_shoot_time).add(90, 'seconds')
                    }

                    //console.log('current time is 00.01 - 04.59 < 05.00', round_id, this.formatDate(curr_time), this.formatDate(this.close_bet_time), )

                }
                else {
                    //current time is 05.01 - 23.59 > 05.00
                    this.end_time = moment().hour(ehh).minute(emm).second(0)
                    this.close_bet_time = moment(this.end_time).subtract(1, 'seconds')
                    this.close_shoot_time = moment(this.close_bet_time).add(2, 'minutes')
                    this.end_process_time = moment(this.close_shoot_time).add(90, 'seconds')

                    if ( round_id > 73 ) {

                        //bet in advance, cancel date must be tomorrow
                        let tomorrow = moment().add(1, 'days')
                        this.end_time = moment(tomorrow).hour(ehh).minute(emm).second(0)
                        this.close_bet_time = moment(this.end_time).subtract(1, 'seconds')
                        this.close_shoot_time = moment(this.close_bet_time).add(2, 'minutes')
                        this.end_process_time = moment(this.close_shoot_time).add(90, 'seconds')
                    }
                    else if ( round_id == 73 ) {
                        //bet in today, cancel date is today
                        let tomorrow = moment().add(1, 'days')
                        this.end_time = moment(tomorrow).hour(0).minute(0).second(0)
                        this.close_bet_time = moment(this.end_time).subtract(1, 'seconds')
                        this.close_shoot_time = moment(this.close_bet_time).add(2, 'minutes')
                        this.end_process_time = moment(this.close_shoot_time).add(90, 'seconds')

                    }

                    //console.log('current time is 05.01 - 23.59 > 05.00', round_id, this.formatDate(curr_time), this.formatDate(this.close_bet_time))

                }

                //console.log('loadSpecificRound start end', moment(this.start_time).format('DD/MM/YYYY HH:mm:ss'), moment(this.close_bet_time).format('DD/MM/YYYY HH:mm:ss'))

                this.round_data = response

                if ( moment().isAfter(this.end_process_time) ) {
                    //console.log('OVERTIME, SHOW RESULT')

                    this.ruleIsHidden = true
                    this.shootTableIsHidden = true
                    this.resultIsHidden = false

                    this.$refs.boxrule.style["display"] = "none"
                    this.$refs.boxresult.style["display"] = "block"
                    this.$refs.boxshoottable.style["display"] = "none"

                    //await this.getLottoResult()
                }
                else {

                    if ( moment().isAfter(this.close_shoot_time) ) {
                        //console.log('OVER SHOOTTIME, SHOW IN PROGRESS')

                        this.ruleIsHidden = true
                        this.shootTableIsHidden = true
                        this.resultIsHidden = false

                        this.$refs.boxrule.style["display"] = "none"
                        this.$refs.boxresult.style["display"] = "block"
                        this.$refs.boxshoottable.style["display"] = "none"
                    }
                    else {

                        if ( moment().isAfter(this.close_bet_time) ) {
                            //console.log('OVER BETTIME, SHOW SHOOTING PROCESS')
 
                            this.ruleIsHidden = true
                            this.shootTableIsHidden = false
                            this.resultIsHidden = true


                            this.$refs.boxrule.style["display"] = "none"
                            this.$refs.boxresult.style["display"] = "none"
                            this.$refs.boxshoottable.style["display"] = "block"

                        }
                        else {
                            //console.log('IN TIME, CAN BET')

                            this.ruleIsHidden = false
                            this.shootTableIsHidden = true
                            this.resultIsHidden = true

                            this.$refs.boxrule.style["display"] = "block"
                            this.$refs.boxresult.style["display"] = "none"
                            this.$refs.boxshoottable.style["display"] = "none"
                        }

                    }

                }

                //assign bet rate
                if ( response.bet_rate ) {
                    this.bettypeRateMapping = response.bet_rate
                }

                //console.log('loadSpecificRound round_data', this.round_data)
                // console.log('loadSpecificRound current_time', moment(this.current_time).format('DD/MM/YYYY HH:mm:ss'))
                // console.log('loadSpecificRound start', moment(this.start_time).format('DD/MM/YYYY HH:mm:ss'))
                // console.log('loadSpecificRound close_bet_time', moment(this.close_bet_time).format('DD/MM/YYYY HH:mm:ss'))
                // console.log('loadSpecificRound close_shoot_time', moment(this.close_shoot_time).format('DD/MM/YYYY HH:mm:ss'))
                // console.log('loadSpecificRound end_process_time', moment(this.end_process_time).format('DD/MM/YYYY HH:mm:ss'))

            } catch (error) {
                console.log('error', error)
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        async loadOverLimitNumber () {

            if ( !this.overLimitEnable ) {
                return
            }

            try {

                let round_date = moment().format('YYYY-MM-DD')

                let LOTTO_ROUND = this.$route.params.round

                // start 00.00.00 of new day
                if ( LOTTO_ROUND > 73 ) {

                    let start_time = moment().hour(5).minute(0).second(0)

                    // current time before start time, bet in advance
                    if ( moment().isBefore(start_time) ) {

                        let yesterday = moment().subtract(1, 'days')
                        round_date = moment(yesterday).format('YYYY-MM-DD')

                    }
                }

                let param = {
                    round: this.$route.params.round,
                    lottotype_id: LOTTO_TYPE_ID,
                    round_date: round_date,
                }

                const response = await this.$store.dispatch('betlimit/getOverLimitNumber', param)
                //console.log('loadOverLimitNumber', response)

                if ( response.length > 0 ) {
                    //console.log('OverLimitNumber', response)
                    this.overLimitData = response[0]
                }

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        generateOverLimitByType(bet_type, isClick) {

            //console.log('generateOverLimitByType', bet_type, isClick)

            if ( !this.overLimitEnable ) {
                return
            }

            let overlimit_data = this.overLimitData

            let number = overlimit_data[bet_type]
            // console.log('overlimit_data', bet_type, number)

            if ( number ) {
                for (let i = 0; i < number.length; i++) {
                    let num = number[i]

                    if ( bet_type == 1 ) {
                        let permutArray = this.permut(num)
                        let unique = permutArray.filter((v, i, a) => a.indexOf(v) === i)
                        //console.log('theemix', num, unique)

                        for (let i = 0; i < unique.length; i++) {
                            if ( isClick ) {
                                this.disableNumber(unique[i], bet_type)
                            }
                            else {
                                this.enableNumber(unique[i], bet_type)
                            }
                        }
                    }
                    else {
                        if ( isClick ) {
                            this.disableNumber(num, bet_type)
                        }
                        else {
                            this.enableNumber(num, bet_type)
                        }
                    }
                }
            }

        },

        disableNumber(num, bet_type) {

            let numtype = this.bettypeCartMapping[bet_type]
            let buttonClass = this.bettypeButtonClassMapping[bet_type]

            let bet_type_same_class = this.bettypeClassGroupMapping[bet_type] 
            let buttonSameGroupClass = this.bettypeButtonClassMapping[bet_type_same_class]

            let ref_num = numtype + '_' + num

            if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].classList.contains("btn-default") ) {
                // button did not selected
                this.$refs[ref_num][0].classList.remove("btn-default")
                this.$refs[ref_num][0].classList.toggle(buttonClass)
                this.$refs[ref_num][0].disabled = true
            }
            else if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].classList.contains("btn-primary") ) {
                // button is seclected
                this.$refs[ref_num][0].classList.remove("btn-primary")
                this.$refs[ref_num][0].classList.toggle(buttonClass)
                this.$refs[ref_num][0].disabled = true
            }
            else if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].disabled ) {
                // button is overlimit with another bettype, add our bettype class 
                if ( this.$refs[ref_num][0].classList.contains(buttonSameGroupClass) ) {
                    this.$refs[ref_num][0].classList.toggle(buttonClass)
                }
               
            }
        },

        enableNumber(num, bet_type) {

            let numtype = this.bettypeCartMapping[bet_type]
            let buttonClass = this.bettypeButtonClassMapping[bet_type]

            let bet_type_same_class = this.bettypeClassGroupMapping[bet_type] 
            let buttonSameGroupClass = this.bettypeButtonClassMapping[bet_type_same_class]

            let ref_num = numtype + '_' + num

            // button is overlimit and contain 2 class then remove our class 
            if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].classList.contains(buttonClass) && this.$refs[ref_num][0].classList.contains(buttonSameGroupClass) ) {
                this.$refs[ref_num][0].classList.remove(buttonClass)
            }
            else if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].classList.contains(buttonClass) ) {
                //contain our class only, remove calss and set enable ( user click bettype button )
                this.$refs[ref_num][0].classList.remove(buttonClass)
                this.$refs[ref_num][0].classList.toggle("btn-default")
                this.$refs[ref_num][0].disabled = false
            }

        },

        getStartTime () {

            let start_time = moment().hour(5).minute(0).second(0)

            //check current date
            if ( moment().isBefore(start_time) ) {
            
                // current time is 00.01 - 04.59 < 05.00
                let yesterday = moment().subtract(1, 'days')
                this.start_time = moment(yesterday).hour(5).minute(0).second(0)

            }
            else {
                //current time is 05.01 - 23.59 > 05.00
                this.start_time = moment().hour(5).minute(0).second(0)
            }

        },

        async getLottoResult () {

            //console.log('getLottoResult', this.round_data.id, this.lotto_result.full_result)
            // get round_id and never get lotto result
            if ( this.round_data.id && !this.lotto_result.full_result ) {

                let round_date = moment().format('YYYY-MM-DD')
                let start_time = moment().hour(5).minute(0).second(0)

                //check current date
                if ( moment().isBefore(start_time) ) {
                    // current time is 00.01 - 04.59 < 05.00
                    let yesterday = moment().subtract(1, 'days')
                    round_date = moment(yesterday).format('YYYY-MM-DD')

                }
                //console.log('round_date', round_date)

                try {
                    let result_query = {
                        lottotype_id: LOTTO_TYPE_ID,
                        round_id: this.round_data.id,
                        date_result: round_date,
                    }
                    //console.log('result_query', result_query)

                    const result_response = await this.$store.dispatch('lottoresult/getLottoResult', result_query)
                    //console.log('result_response', result_response)

                    if ( result_response ) {
                        this.lotto_result = result_response

                        //console.log('yeekeeTableData', this.yeekeeTableData)
                        if ( this.yeekeeTableData.length > 15 ) {
                            //console.log('yeekeeTableData', this.yeekeeTableData[0])
                            if ( this.yeekeeTableData[0].get_reward < 1 ) {
                                //lotto result not finished yet
                                this.$router.push({name: 'allyeekee',})
                            }

                            this.lotto_result.sixteen_number = this.yeekeeTableData[15].number
                            this.lotto_result.first_user = this.yeekeeTableData[0].name
                            this.lotto_result.sixteen_user = this.yeekeeTableData[15].name
                            let cal_result = parseInt( this.yeekeeSumTotal ) - parseInt( this.yeekeeTableData[15].number )

                            let str_result = String(cal_result)
                            let head_number = str_result.substring(0, str_result.length-5)

                            this.lotto_result.cal_result = str_result
                            this.lotto_result.head_number = head_number

                            let full = str_result.slice(-5)
                            let two_number = full.slice(0, 2)
                            let three_number = full.slice(-3)

                            this.lotto_result.two_number = two_number
                            this.lotto_result.three_number = three_number

                            //console.log('cal_result', cal_result, str_result, full, twodown, threetop, head)
                            
                            //this.lotto_result.cal_result = <h1 class="">357<span class="text-success">01</span><span class="text-danger">046</span></h1>
                        }
                        else {
                            this.lotto_result.sixteen_number = ''
                            this.lotto_result.first_user = ''
                            this.lotto_result.sixteen_user = ''
                            this.lotto_result.cal_result = ''
                        }

                    }
                    else {
                        //lotto result not finished yet
                        this.$router.push({name: 'allyeekee',})
                    }

                } catch (error) {
                    console.log('error', error)
                    this.$toasted.error('There was an error connecting to the server.')
                }

            }


        },

        async insertNumber () {
            //console.log('yknumber', this.yknumber, this.clickedInsertNumber, this.yknumber.length)
            if (this.clickedInsertNumber) {
                return
            }

            if ( moment().isAfter(this.close_shoot_time) ) {
                //console.log('OVER SHOOTTIME, SHOW IN PROGRESS', moment(), this.close_shoot_time)
                this.$toasted.error('ไม่สามารถยิงเลขได้ หมดเวลาแล้ว')
                this.$router.go(0)
                return
            }

            if (this.yknumber.length !== 5) {
                this.$toasted.error('Wrong number length')
                return
            }

            if ( !this.validateNumber(this.yknumber) ) {
                this.$toasted.error('ใส่ได้เฉพาะตัวเลขเท่านั้น')
                return
            }

            let yeekeeData = {
                number: this.yknumber,
                //name: this.user.username,
                //user_id: this.user.id,
                round: this.$route.params.round,
            }
            //console.log('yeekeeData', yeekeeData)

            try {
                await this.$store.dispatch('yeekee/createYeekee', yeekeeData)

                this.$toasted.success('yeekee number has been updated.')

                this.clickedInsertNumber = true

                let tableData = {
                    page: 1,
                    pageSize: 20,
                    type: 'init',
                }
                tableData.sort = this.tableProps.defaultSort
                await this.loadYeekeeTable(tableData)

                //this.$refs.yknumber.value = ''
                this.yknumber = ''

                //release the clicked state after a 10 second
                this.insert_timeout = setInterval(this.decrementTime, 1000)


            } catch (error) {
                //console.log('Error response', error.response)
                let error_msg = 'There was an error connecting to the server.'
                let response = error.response.data
                if ( response ) {
                    if ( response.message == 'INVALID_INSERT_YEEKEE_OUT_OF_TIME' ) {
                        error_msg = 'ไม่สามารถยิงเลขได้ หมดเวลาแล้ว'
                    }
                    else {
                        error_msg = response.message
                    }
                }

                this.$toasted.error(error_msg)
                this.$router.go(0)
            }
        },

        randomNumber () {
            let rand_num = Math.floor(100000 + Math.random() * 900000).toString().substring(1)
            this.yknumber = rand_num
        },

        decrementTime () {

            if ( this.countDown > 0 ) {
                this.countDown--
            }
            else {
                this.clickedInsertNumber = false
                clearInterval(this.insert_timeout)
                this.countDown = 10
            }
        },

        async loadYeekeeTable (queryInfo) {

            if ( !queryInfo ) {
                queryInfo = {
                    page: 1,
                    pageSize: 20,
                }
            }

            let yeekeeQuery = {
                order: 'desc',
                page: queryInfo.page - 1,
                limit: queryInfo.pageSize,
                round: this.$route.params.round,
            }

            try {
                const response = await this.$store.dispatch('yeekee/getYeekeeRound', yeekeeQuery)
                //console.log('async loadYeekeeTable', response)
                this.yeekeeTableData = response.result
                this.yeekeeTableTotal = response.count.CNT
                this.yeekeeSumTotal = response.count.SUM

                if ( moment().isAfter(this.end_process_time) ) {
                    await this.getLottoResult()
                }

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            } finally {
                if (this.completedFirstPass === false) { this.completedFirstPass = true }
            }
        },

        hiddenMethod: function (message, event) {
            if (event) {
                event.preventDefault()
                event.stopPropagation()
            }

            // clear all button and value
            for (let k in this.betTypes) {
                let btext = 'butt' + k + 'IsActive'
                this.$data[btext] = false
            }
            this.betTypes = {}

            // helper: hide all number sections
            const hideAllNumberSections = () => {
                this.upIsHidden = true
                this.frontIsHidden = true
                this.downIsHidden = true
                this.runningIsHidden = true
                this.hilowIsHidden = true
                this.evenoddIsHidden = true
            }

            // reset main sections
            this.ruleIsHidden = true
            this.resultIsHidden = true
            this.shootTableIsHidden = true
            this.numberIsHidden = true
            hideAllNumberSections()

            // RULE / RESULT / SHOOT TABLE
            if (message === 'rule') {
                this.ruleIsHidden = false
                return
            }

            if (message === 'result') {
                this.resultIsHidden = false
                return
            }

            if (message === 'shootTable') {
                this.shootTableIsHidden = false
                return
            }

            // NUMBER MODE
            this.numberIsHidden = false

            if (message === 'threetop') {
                this.upIsHidden = false
                return
            }

            if (message === 'threefront') {
                this.frontIsHidden = false
                return
            }

            if (message === 'twodown') {
                this.downIsHidden = false
                return
            }

            if (message === 'running') {
                // บังคับปิดทุกโหมดอื่นแบบชัวร์
                this.upIsHidden = true
                this.frontIsHidden = true
                this.downIsHidden = true
                this.hilowIsHidden = true
                this.evenoddIsHidden = true

                this.runningIsHidden = false
                return
            }

            if (message === 'hilow') {
                this.hilowIsHidden = false
                return
            }

            if (message === 'evenodd') {
                this.evenoddIsHidden = false
                return
            }
        },
        numClickMethod: function (type, event) {
            if (event) event.preventDefault()
            this.numIsDisable = false

            //console.log('userCredit', this.userCredit)
            // active/deactive button
            let butttext = 'butt' + type + 'IsActive'
            //alert(butttext)
            this.$data[butttext] = !this.$data[butttext]

            this.generateOverLimitByType( this.bettypeCodeMapping[type], this.$data[butttext] )

            // keep rate
            //var key = 'hash' + type
            //alert(key)
            if ( this.$data[butttext] ) {
                //this.betTypes[type] = { type: type, text: this.$data[key].text, rate: this.$data[key].rate }
                this.betTypes[type] = { 
                    type: type,
                    text: this.bettypeTextMapping[type],
                    rate: this.bettypeRateMapping[type],
                    disc: this.bettypeDiscountMapping[type]
                }
                
            }
            else {
                delete this.betTypes[type]
            }
            //console.log(type, this.betTypes[type])

            //console.log('numClickMethod betTotal: ', this.betTotal())

        },
        addCart: function (num, numtype, event) {
            if (event) event.preventDefault()

            if ( this.betvalue < 1 ) {
                alert('จำนวนเงินที่ท่านแทง ไม่สามารถแทงได้')
                return
            }

            if ( this.permutFlag && ( numtype === 'up' || numtype === 'front' || numtype === 'down' ) ) {
                //console.log('num', num)
                let permutArray = this.permut(num)
                //console.log('permutArray', num, permutArray)

                let unique = permutArray.filter((v, i, a) => a.indexOf(v) === i)
                //console.log('unique', num, unique)

                for (let i = 0; i < unique.length; i++) {
                    this.pushItemToCart(unique[i], numtype, event)
                }
            }
            else {
                this.pushItemToCart(num, numtype, event)
            }
        },

        pushItemToCart(num, numtype, event) {

            //console.log('pushItemToCart', num, numtype)
            var betvaluetot = 0
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    betvaluetot = parseFloat(betvaluetot) + parseFloat(this.$data[carttext][j].betvalue)
                }
            }

            // protect over credit
            betvaluetot = betvaluetot + 1


            if ( betvaluetot <=  this.userCredit) {
                this.numIsDisable = false
                for (let key in this.betTypes){

                    //console.log('addcart ', key, this.betTypes[key])
                    let winprice = parseFloat(this.betTypes[key].rate) * this.betvalue

                    var carttext = key + 'Cart'

                    // check if num is the same existing number then update betvalue
                    // not support ie
                    let objIndex = this.$data[carttext].findIndex((obj => obj.number === num))
                    //console.log('addCart objIndex', objIndex)


                    if ( objIndex > -1 ) {

                        //let r = confirm('การกดแทงเลขที่เคยแทงแล้ว จะเป็นการยกเลิกการแทงเลขนั้นๆ, คุณต้องการยกเลิก ใช่ หรือ ไม่?')
                        //if (r == true) { this.deleteItems(objIndex, key) }
                        this.deleteItems(objIndex, key)

                    }
                    else {

                        let ref_num = numtype + '_' + num
                        //console.log('add cart', ref_num, this.$refs[ref_num])

                        const refNode = this.$refs[ref_num] && this.$refs[ref_num][0]

                        if (refNode && refNode.classList.contains("btn-default")) {
                            refNode.classList.remove("btn-default")
                            refNode.classList.add("btn-primary")
                        }
                        // new number push to array
                        this.$data[carttext].push( { 
                            number: num,
                            type: this.betTypes[key].type,
                            text: this.betTypes[key].text,
                            betvalue: this.betvalue,
                            winprice: winprice.toFixed(2),
                            rate: this.betTypes[key].rate,
                            ref_num: ref_num,
                            successResult: 0,
                            failResult: 0,
                        } )
                    }
                }

            }
            else {
                if ( this.numIsDisable == false ) {
                    alert('ไม่สามารถแทงได้ เกินวงเงิน')
                    this.numIsDisable = true
                }
            }
        },

        calculateWinPrice(index, type, event) {

            if ( !this.validateBetNumber(event.target.value) ) {
                this.$toasted.error('จำนวนเงินไม่ถูกต้อง')
                // reset value to 1
                event.target.value = 1
            }

            if (event) event.preventDefault()
            //console.log( 'event.target', event.target )
            var carttext = type + 'Cart'
            this.$data[carttext][index].betvalue = event.target.value
            var rate = ( parseFloat(event.target.value) * parseFloat(this.$data[carttext][index].rate) ) || this.$data[carttext][index].rate
            this.$data[carttext][index].winprice =  rate.toFixed(2)

            //this.betvalue = ( parseFloat(event.target.value) + parseFloat(this.betvalue) )
        },
        deleteItems(index, type, event) {

            var carttext = type + 'Cart'
            //console.log(carttext + '1 ', this.$data[carttext])
            //console.log('deleteItems', this.betvalue, index)
            //this.betvalue = ( parseFloat(this.betvalue) - parseFloat(this.$data[carttext][index].betvalue) )


            let ref_num = this.$data[carttext][index].ref_num
            const refNode = this.$refs[ref_num] && this.$refs[ref_num][0]

            if (refNode && refNode.classList.contains("btn-primary")) {
                refNode.classList.remove("btn-primary")
                refNode.classList.add("btn-default")
            }

            this.$delete(this.$data[carttext], index)
            //console.log(carttext + '2 ', this.$data[carttext])

        },

        deleteAllItems(event) {

            let r = confirm('ยืนยันการล้างข้อมูล ลบชุดตัวเลขที่คุณได้เลือกไว้ทั้งหมด?')
            if (r == true) {
                this.clearAll()
            }

        },

        clearAll() {
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]

                for (let j = 0; j < this.$data[carttext].length; j++) {
                    let ref_num = this.$data[carttext][j].ref_num
                    const refNode = this.$refs[ref_num] && this.$refs[ref_num][0]

                    if (refNode && refNode.classList.contains("btn-primary")) {
                        refNode.classList.remove("btn-primary")
                        refNode.classList.add("btn-default")
                    }
                }

                this.$data[carttext] = []
            }

            this.totalSuccessResult = 0
            this.totalFailResult = 0
            this.orderNumber = 0
        },

        closeOutsideModal(e) {
            //console.log('closeOutsideModal', e)
            this.continueBet()
        },
        continueBet() {
            this.clearAll()

            //console.log('orderBettype', this.orderBettype)
            // generate new overlimit button
            for ( let key in this.orderBettype) {
                this.generateOverLimitByType( key, true )
            }
            this.orderBettype = {}

        },

        showCheckoutSuccess() {
            this.$refs.clickCheckoutSuccess.click()
        },
        showButtonDelete() {
            this.$refs.clickDeleteButton.click()
        },
        redirectTransaction() {
            this.$router.push('/transaction')
        },
        onlyNumber ($event) {
            //console.log($event.keyCode) //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
            if (keyCode < 48 || keyCode > 57) {
                $event.preventDefault()
            }
        },
        validateBetNumber (amount) {
            let rgx = /^[0-9]+$/g
            if ( amount.toString().match(rgx) && amount > 0 ) {
                return 1
            }
            return 
        },

        validateNumber (amount) {
            let rgx = /^[0-9]+$/g
            return amount.match(rgx)
        },

        searchNumber({ type, target }) {

            let filter = target.value
            console.log(filter)

            for (let i = 1; i < 11; i++) {
                let tabtext = 'tab' + i
                console.log('tabtext: ', tabtext)
                let parentdiv = document.getElementById(tabtext)
                console.log(parentdiv)
                let childdiv = parentdiv.getElementsByTagName('div')
                console.log(childdiv.length)

                for (let i = 0; i < childdiv.length; i++) {
                    let b = childdiv[i].getElementsByTagName("button")[0]
                    //console.log(b.innerHTML + ' : ' + filter + ' : ' + b.innerHTML.indexOf(filter))
                    if (b.innerHTML.indexOf(filter) > -1) {
                        childdiv[i].style.display = ""
                        //console.log(b.innerHTML + ' : ' + filter + ' : ' + b.innerHTML.indexOf(filter))
                    } else {
                        childdiv[i].style.display = "none"
                    }
                }

            }

        },

        setCustomBetValue(event) {

            let customBet = event.target.value
            //console.log('customBet', customBet)

            if ( !this.validateBetNumber(customBet) ) {
                this.$toasted.error('จำนวนเงินไม่ถูกต้อง')
                // reset value to 1
                customBet = 1
            }

            this.betvalue = customBet
            this.customBetValue = this.betvalue

        },

        setAllSamePrice() {
            // console.log('sameBetValue', this.sameBetValue)

            let newSameBet = this.sameBetValue

            if ( !this.validateBetNumber(newSameBet) ) {
                this.$toasted.error('จำนวนเงินไม่ถูกต้อง')
                // reset value to 1
                this.sameBetValue = 1
                return
            }

            for (let i = 0; i < this.defaultCartTypes.length; i++) {

                let carttext = this.defaultCartTypes[i]
                //loopItemData:
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    let cart_item = this.$data[carttext][j]

                    this.$data[carttext][j].betvalue = newSameBet
                    let newWinRate =
                        parseFloat(newSameBet) * parseFloat(cart_item.rate)
                    this.$data[carttext][j].winprice = newWinRate
                }
            }

            // reset value
            this.sameBetValue = ''

        },

        async createOrderhead () {

            if ( moment().isAfter(this.close_bet_time) ) {
                this.$toasted.error('ไม่สามารถแทงได้ หมดเวลา')
                return 
            }

            //this.setBetValue(this.betvalue)
            this.totalSuccessResult = 0
            this.totalFailResult = 0

            let betvaluetot = this.betTotal()

            let round_date = moment().format('YYYY-MM-DD')

            let LOTTO_ROUND = this.$route.params.round

            // start 00.00.00 of new day
            if ( LOTTO_ROUND > 73 ) {

                let start_time = moment().hour(5).minute(0).second(0)

                // current time before start time, bet in advance
                if ( moment().isBefore(start_time) ) {

                    let yesterday = moment().subtract(1, 'days')
                    round_date = moment(yesterday).format('YYYY-MM-DD')

                }
            }

            let orderData = {
                itemdata: [],
                oh_total: betvaluetot,
                status_id: 1, // pending
                currency_id: 1, //THB
                round: LOTTO_ROUND,
                lottotype_id: LOTTO_TYPE_ID, // fix lotto type 4=GOV
                //oh_ordnum: this.orderNumber,
                comment: '',
                round_date: round_date,
                //country_id: this.round_data.country_id,
                round_id: this.round_data.id,
            }

            let orderTotal = 0

            let allItemData = []
            for (let i = 0; i < this.defaultCartTypes.length; i++) {

                let carttext = this.defaultCartTypes[i]
                //loopItemData:
                for (let j = 0; j < this.$data[carttext].length; j++) {

                    let bettype = this.$data[carttext][j].type
                    let bettype_id = this.bettypeCodeMapping[bettype]

                    let itemData = {
                        oh_id: 0,
                        number: this.$data[carttext][j].number,
                        bet_value: this.$data[carttext][j].betvalue,
                        rate: this.$data[carttext][j].rate,
                        win_price: this.$data[carttext][j].winprice,

                        bettype_id: bettype_id,
                        status_id: 4, // fix complete
                        currency_id: orderData.currency_id,

                        oi_can: 0,
                        oi_rollback: 0,
                        oi_win: 0,

                        bettype: bettype,
                    }
                    //console.log('itemData', itemData)
                    allItemData.push( itemData )
                    this.orderBettype[bettype_id] = 1
                }
            }

            orderData['itemdata'] = allItemData

            let loader = this.$loading.show()

            try {

                //console.log('createOrderhead orderData: ', orderData)

                const responseCreate = await this.$store.dispatch('orderhead/createOrderhead', orderData)
                //console.log('createOrderhead responseCreate: ', responseCreate)

                orderTotal = responseCreate.data.orderTotal

                // orderTotal must have value
                if ( orderTotal > 0 ) {

                    // let insertId = responseCreate.data.id
                    // const orderId = insertId[0]

                    this.processItems = responseCreate.data.resultItems
                    this.totalSuccessResult = responseCreate.data.totalSuccess.toFixed(2)
                    this.totalFailResult = responseCreate.data.totalFail.toFixed(2)
                    this.orderNumber = responseCreate.data.orderNumber

                    this.showCheckoutSuccess()
                }
                else {
                    this.$toasted.error('ไม่สามารถแทงได้ เกินจำนวนลิมิต')
                }
 
            } catch (error) {
                let error_msg = 'There was an error connecting to the server.'
                let response = error.response.data
                if ( response ) {
                    error_msg = response.message
                }
                this.$toasted.error(error_msg)

                if ( response.message == 'INVALID_CREATED_TIME_FOR_ORDER' ) {
                    this.$router.push({name: 'lottery',})
                }
            } finally {
                this.$root.$emit('navbar')
                this.doubleClickKey += 1
                loader.hide()
                await this.loadOverLimitNumber()
            }
        },

        betTotal() {
            var betvaluetot = 0
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    betvaluetot = parseFloat(betvaluetot) + parseFloat(this.$data[carttext][j].betvalue)
                }
            }
            return betvaluetot
        },
        setBetValue(betvalue, event) {
            //console.log('setBetValue betvalue: ', betvalue)

            this.bet1Style = ''
            this.bet5Style = ''
            this.bet25Style = ''
            this.bet100Style = ''
            this.bet500Style = ''

            //let betref = 'bet' + betvalue + 'Style'
            //console.log(this.$data[betref], betref)
            //this.$data[betref] = "background-color: #DCDCDC"
            //console.log(this.$data[betref])

            //this.betvalue = betvalue
            //this.customBetValue = betvalue

            this.betvalue = parseFloat(this.betvalue) + parseFloat(betvalue)
            this.customBetValue = this.betvalue

        },

        clearBetValue () {
            //console.log('clearBetValue', this.betvalue)
            this.betvalue = 0
            this.customBetValue = 0
        },

        async loadUserBalance () {
            try {
                const response = await this.$store.dispatch('ledger/getUserBalance', this.user.account_id)
                //console.log('GOVHOME response: ', response)
                this.userCredit = response.balance.toFixed(2)
            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
                this.$store.dispatch('user/userLogout')
            }
        },

        leftPad(number, targetLength) {
            let output = number + ''
            while (output.length < targetLength) {
                output = '0' + output
            }
            return output
        },

        createArray(first, last, str_len) {
            let arr = []
            for(var i=first; i<=last; i++) {
                let value = this.leftPad(i, str_len)
                arr.push(value.toString())
            }
            //console.log(arr)
            return arr
        },

        setPermutFlag() {
            this.permutFlag = !this.permutFlag
            //console.log('permutFlag', this.permutFlag)
            if ( event.target.classList.contains("btn-default") ) {

                event.target.classList.remove("btn-default")
                event.target.classList.toggle("btn-primary")
            }
            else {
                event.target.classList.remove("btn-primary")
                event.target.classList.toggle("btn-default")
            }
        },

        permut(string) {
            //console.log('permut string', string)
            let results = []

            if (string.length === 1) {
                results.push(string)
                return results
            }

            for (let i = 0; i < string.length; i++) {
                let firstChar = string[i]
                let charsLeft = string.substring(0, i) + string.substring(i + 1)
                let innerPermutations = this.permut(charsLeft)
                for (let j = 0; j < innerPermutations.length; j++) {
                    results.push(firstChar + innerPermutations[j])
                }
            }
            return results
        },


        slideFront(num, event) {
            //console.log('slideFront', num)

            if ( this.betvalue < 1 ) {
                alert('จำนวนเงินที่ท่านแทง ไม่สามารถแทงได้')
                return
            }

            for(var i=0; i<=9; i++) {
                let value = num.toString() + i
                //console.log('slideFront', i, value, event)
                this.addCartSkipDuplicated(value, event)
            }

        },

        slideBack(num, event) {
            //console.log('slideBack', num)

            if ( this.betvalue < 1 ) {
                alert('จำนวนเงินที่ท่านแทง ไม่สามารถแทงได้')
                return
            }

            for(var i=0; i<=9; i++) {
                let value =  i + num.toString()
                //console.log('slideFront', i, value)
                this.addCartSkipDuplicated(value, event)
            }
        },

        slide19goal(num, event) {
            //console.log('slide19goal', num)

            if ( this.betvalue < 1 ) {
                alert('จำนวนเงินที่ท่านแทง ไม่สามารถแทงได้')
                return
            }

            let arr = []
            for(var i=0; i<=9; i++) {
                let front = num.toString() + i
                let back =  i + num.toString()
                arr.push(front, back)
            }

            let unique = arr.filter((v, i, a) => a.indexOf(v) === i)
            for (let i = 0; i < unique.length; i++) {
                this.addCartSkipDuplicated(unique[i], event)
            }

        },

        addCartSkipDuplicated: function (num, event) {
            //if (event) event.preventDefault()

            var betvaluetot = 0
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    betvaluetot = parseFloat(betvaluetot) + parseFloat(this.$data[carttext][j].betvalue)
                }
            }

            // protect over credit
            betvaluetot = betvaluetot + 1


            if ( betvaluetot <=  this.userCredit) {
                this.numIsDisable = false
                for (let key in this.betTypes){

                    let winprice = parseFloat(this.betTypes[key].rate) * this.betvalue
                    var carttext = key + 'Cart'

                    // check if num is the same existing number then update betvalue
                    // not support ie
                    let objIndex = this.$data[carttext].findIndex((obj => obj.number === num))


                    if ( objIndex > -1 ) {
                        // do nothing
                    }
                    else {
                        // down_00 for 2down only
                        let ref_num = 'down_' + num

                        if ( this.$refs[ref_num][0].classList.contains("btn-default") ) {
                            this.$refs[ref_num][0].classList.remove("btn-default")
                            this.$refs[ref_num][0].classList.toggle("btn-primary")
                        }

                        // new number push to array
                        this.$data[carttext].push( { 
                            number: num,
                            type: this.betTypes[key].type,
                            text: this.betTypes[key].text,
                            betvalue: this.betvalue,
                            winprice: winprice.toFixed(2),
                            rate: this.betTypes[key].rate,
                            ref_num: ref_num,
                            successResult: 0,
                            failResult: 0,
                        } )
                    }
                }

            }
            else {
                if ( this.numIsDisable == false ) {
                    alert('ไม่สามารถแทงได้ เกินวงเงิน')
                    this.numIsDisable = true
                }
            }
        },

        formatDate (value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        startCallBack: function (x) {
            //console.log('startCallBack', this.formatDate(x))
        },

        endShootTime: function (x) {
            // ถ้าเป็นรอบเก่าที่ออกผลจบไปแล้ว ไม่ต้องเปลี่ยน state อะไรอีก
            if (moment().isSameOrAfter(this.end_process_time)) {
                return
            }

            // ทำงานเฉพาะตอน shoot table กำลังเปิดอยู่จริง
            if (this.shootTableIsHidden) {
                return
            }

            this.clearAll()
            this.hiddenMethod('result')
        },

        endBetTime: function (x) {
            // ถ้าเลยช่วงยิงเลขไปแล้ว หรือเป็นรอบเก่าที่ดูผลอยู่
            // ห้ามสลับกลับไป shootTable เพราะจะทำให้ loop
            if (moment().isSameOrAfter(this.close_shoot_time)) {
                return
            }

            // ทำงานเฉพาะตอนหน้า rule กำลังเปิดอยู่จริง
            if (this.ruleIsHidden) {
                return
            }

            this.clearAll()
            this.hiddenMethod('shootTable')
        },

        async endProcessTime(x) {
            //console.log('endProcessTime', x)

            //await this.getLottoResult()
        },

        formatRewardNumber (get_reward, raw_number, index) {

            if ( get_reward == 1 && index == 15 ) {
                return '<span class="text-info"><strong>'+ raw_number +'</strong></span>'
            }

            return raw_number
        },

        formatRewardName (get_reward, name, index) {

            if ( get_reward == 1 ) {

                if ( index == 0 ) {
                    return '<span class="text-navy"><strong>'+ name +'</strong></span>'
                }
                else if ( index == 15 ) {
                    return '<span class="text-danger"><strong>'+ name +'</strong></span>'
                }
            }
            return name.replace(name.substring(2, 5), "***")
        },

        formatYeekeeName (name, index) {

            if ( index == 0 ) {
                return '<span class="text-navy"><strong>'+ name +'</strong></span>'
            }
            else if ( index == 15 ) {
                return '<span class="text-danger"><strong>'+ name +'</strong></span>'
            }

            return name.replace(name.substring(2, 5), "***")
        },

        formatMoney(num) {
            if (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },

        async loadUserNumber () {
            //console.log('loadUserNumber')
            let loader = this.$loading.show()
            try {
                const response = await this.$store.dispatch('usernumber/getAllUsernumber', { order: 'desc', })
                //console.log('async loadUserNumber', response)

                this.userNumberSet = response.result

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            } finally {
                loader.hide()
            }
        },

        async selectNumber (setId) {
            try {
                const response = await this.$store.dispatch('usernumber/getUsernumber', setId)
                //console.log('response: ', response)

                if ( response.length > 0 ) {

                    //clear cart before add number
                    this.clearAll()

                    let copyBetType = Object.assign({}, this.betTypes) 
                    this.clearBetType()

                    for (let i = 0; i < response.length; i++) {
                        let bettype_id = response[i].bettype_id
                        let number = response[i].number

                        let type = this.bettypeIdMapping[bettype_id]

                        //console.log('selectNumber', bettype_id, type, number)

                        this.betTypes[type] = { 
                            type: type,
                            text: this.bettypeTextMapping[type],
                            rate: this.bettypeRateMapping[type],
                            disc: this.bettypeDiscountMapping[type]
                        }

                        //this.numClickMethod(type)

                        let cart_type = this.bettypeCartMapping[bettype_id]
                        this.addCart( number, cart_type)

                        delete this.betTypes[type]
                    }
                    this.betTypes = copyBetType
                    this.$refs.closeUserNumber.click()
                }
                
            } catch (error) {
                console.log('error', error)
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        async loadOrderHistory () {
            let loader = this.$loading.show()
            try {
                const response = await this.$store.dispatch('orderhead/getUsersOrderhead', { order: 'desc', type: 'numberset', limit: 10 })
                //console.log('async loadOrderHistory', response)

                this.orderHistoryData = response.orderData

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            } finally {
                loader.hide()
            }
        },

        async selectOrder (orderId) {
            try {

                const response = await this.$store.dispatch('orderitem/getOrderitem', orderId)
                //console.log('response: ', response, this.betvalue)


                if ( response.length > 0 ) {

                    //clear cart before add number
                    this.clearAll()

                    let copyBetType = Object.assign({}, this.betTypes) 
                    this.clearBetType()

                    let current_betvalue = this.betvalue
                    for (let i = 0; i < response.length; i++) {

                        let bettype_id = response[i].bettype_id
                        let number = response[i].number

                        let type = this.bettypeIdMapping[bettype_id]

                        this.betvalue = response[i].bet_value

                        //console.log('selectNumber', bettype_id, type, number)

                        this.betTypes[type] = { 
                            type: type,
                            text: this.bettypeTextMapping[type],
                            rate: this.bettypeRateMapping[type],
                            disc: this.bettypeDiscountMapping[type]
                        }

                        //this.numClickMethod(type)

                        let cart_type = this.bettypeCartMapping[bettype_id]
                        this.addCart( number, cart_type)

                        delete this.betTypes[type]
                    }
                    this.betvalue = current_betvalue
                    this.betTypes = copyBetType
                    this.$refs.closeUserNumber.click()

                }

                
            } catch (error) {
                console.log('error', error)
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        clearBetType() {
            for (let key in this.betTypes){
                delete this.betTypes[key]
            }
        },

    },
    beforeDestroy () {
        // clear the timeout before the component is destroyed
        clearInterval(this.insert_timeout)
        clearInterval(this.refresh_interval)
    }
}
</script>

<style scoped>
.bet-page-shell {
  padding: 10px 0 28px;
  background:
    radial-gradient(circle at top left, rgba(42, 110, 107, 0.10), transparent 26%),
    radial-gradient(circle at top right, rgba(186, 211, 210, 0.18), transparent 28%),
    linear-gradient(180deg, #edf4f3 0%, #e7efee 100%);
  min-height: calc(100vh - 80px);
}

.bet-page-container {
  padding: 0 12px 24px;
}

.bet-page-header-wrap {
  margin-bottom: 14px;
}

.bet-hero-card,
.bet-section-card,
.bet-cart-card {
  border: 1px solid rgba(42, 110, 107, 0.18);
  border-radius: 24px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(246,250,250,0.96) 100%);
  box-shadow: 0 18px 40px rgba(26, 79, 75, 0.08);
}

.bet-hero-card > .ibox-title,
.bet-section-card > .ibox-title,
.bet-cart-card > .ibox-title {
  border-bottom: 1px solid rgba(42, 110, 107, 0.14);
  background: linear-gradient(180deg, rgba(249,252,252,0.98) 0%, rgba(241,247,247,0.98) 100%);
}

.bet-hero-card__title {
  padding: 18px 22px 14px;
}

.bet-hero-card__crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #5f7574;
  margin-bottom: 6px;
}

.bet-hero-card__crumb-link {
  color: #1A4F4B !important;
  font-weight: 600;
}

.bet-hero-card__crumb-sep {
  opacity: 0.55;
}

.bet-hero-card__name {
  margin: 0;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 700;
  color: #1a2e2d;
}

.bet-hero-card__content {
  background: transparent;
}

.bet-slug-nav {
  margin-bottom: 0;
  border: 0;
  background: transparent;
  min-height: auto;
}

.bet-slug-nav .navbar-collapse {
  padding-left: 10px;
  padding-right: 10px;
}

.bet-slug-nav__list {
  float: none !important;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 16px 18px;
}

.bet-slug-nav__list > li {
  float: none !important;
  margin: 0 !important;
  border: 0 !important;
}

.bet-slug-nav__list > li > a.bet-tab-pill {
  display: block;
  border-radius: 999px !important;
  border: 1px solid #d8872f !important;
  background: linear-gradient(135deg, #f2a23a 0%, #d8831f 100%) !important;
  color: #111 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  padding: 14px 22px !important;
  min-height: 52px;
  line-height: 1.2;
  transition: all 0.2s ease !important;
}

.bet-slug-nav__list > li.active > a.btn-bet-info,
.bet-slug-nav__list > li > a.btn-bet-info:hover,
.bet-slug-nav__list > li > a.btn-bet-info:focus {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%);
  border-color: transparent;
  color: #fff !important;
}

.bet-main-shell {
  background: transparent;
  box-shadow: none;
  border: 0;
}

.bet-main-column,
.bet-side-column {
  padding-top: 4px;
}

.bet-section-card {
  margin-bottom: 16px;
}

.bet-section-card > .ibox-content {
  padding: 20px 18px;
  background: transparent;
}

.bet-section-card > .ibox-title {
  padding: 16px 18px;
}

.bet-price-toolbar h5,
.bet-cart-card__title h5,
.bet-section-card .ibox-title h5 {
  font-size: 16px;
  font-weight: 700;
  color: #1a2e2d;
}

.bet-money-input {
  margin-top: 6px;
}

.bet-price-toolbar .input-group .form-control,
.bet-cart-card .input-group .form-control,
.bet-section-card .form-control {
  height: 44px;
  border-radius: 14px;
  border: 1px solid rgba(42, 110, 107, 0.25);
  box-shadow: none;
  background: #fbfdfd;
  color: #1e2e2d;
}

.bet-price-toolbar .input-group-btn > .btn,
.bet-cart-card .input-group-btn > .btn {
  height: 44px;
  border-radius: 14px;
  border: 1px solid rgba(42, 110, 107, 0.18);
  background: linear-gradient(180deg, #ffffff 0%, #eff6f6 100%);
  color: #1A4F4B;
  font-weight: 600;
}

.bet-money-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.bet-subtype-group .btn,
#boxrunning .btn,
#boxhilow .btn,
#boxevenodd .btn,
#box-number2dtop .btn,
#box-number2ddown .btn,
#box-number3dtop .btn,
#box-number3dmix .btn {
  border-radius: 14px !important;
  border: 1px solid rgba(42, 110, 107, 0.18) !important;
  background: linear-gradient(180deg, #ffffff 0%, #f3f8f8 100%) !important;
  color: #1A4F4B !important;
  font-weight: 600;
  box-shadow: 0 8px 18px rgba(26, 79, 75, 0.05);
}

.bet-subtype-group .btn.btn-primary,
#boxrunning .btn.btn-primary,
#boxhilow .btn.btn-primary,
#boxevenodd .btn.btn-primary,
#box-number2dtop .btn.btn-primary,
#box-number2ddown .btn.btn-primary,
#box-number3dtop .btn.btn-primary,
#box-number3dmix .btn.btn-primary {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  color: #fff !important;
  border-color: transparent !important;
}

.bet-cart-card {
  position: sticky;
  top: 88px;
}

.bet-cart-card__title {
  position: relative;
  padding: 16px 18px;
}

.bet-cart-card__shortcut {
  position: absolute;
  top: 12px;
  right: 18px;
  border-radius: 999px;
  border: 0;
  padding: 7px 14px;
  font-weight: 700;
  box-shadow: 0 10px 18px rgba(255, 193, 7, 0.18);
}

.bet-cart-card__content {
  padding: 18px;
  background: transparent;
}

.bet-cart-card h4 {
  font-size: 14px;
  font-weight: 700;
  color: #1A4F4B;
  padding-bottom: 6px;
  border-bottom: 1px dashed rgba(42, 110, 107, 0.20);
}

.bet-cart-card .input-group-addon {
  border-radius: 14px 0 0 14px;
  border: 1px solid rgba(42, 110, 107, 0.22);
  background: #eef5f5;
  color: #1A4F4B;
  font-weight: 700;
}

.bet-cart-card .input-group-btn > .btn.btn-default {
  background: #f2f7f7 !important;
  color: #235E59 !important;
  border-color: rgba(42, 110, 107, 0.18) !important;
}

.bet-cart-card .input-group-btn > .btn.btn-danger {
  border-radius: 0 14px 14px 0;
}

.money-chips.bet-money-chips {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  margin-top: 12px;
  overflow: visible !important;
}

.coin-chip {
  --chip-main: #235E59;
  --chip-dark: #1A4F4B;
  --chip-light: #2A8C87;
  position: relative;
  width: 54px;
  height: 54px;
  min-width: 54px;
  min-height: 54px;
  border: 0;
  border-radius: 50%;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 17px;
  line-height: 1;
  color: #ffffff !important;
  cursor: pointer;
  user-select: none;
  z-index: 1;
  overflow: hidden;
  text-indent: 0 !important;
  background:
    radial-gradient(circle at 30% 28%, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.45) 14%, rgba(255,255,255,0) 28%),
    radial-gradient(circle at center, var(--chip-light) 0%, var(--chip-main) 58%, var(--chip-dark) 100%);
  box-shadow:
    inset 0 2px 3px rgba(255,255,255,0.38),
    inset 0 -4px 6px rgba(0,0,0,0.18),
    0 8px 16px rgba(26, 79, 75, 0.14);
}

.coin-chip::before {
  content: "";
  position: absolute;
  inset: 5px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.88);
  box-shadow:
    inset 0 1px 2px rgba(255,255,255,0.35),
    0 0 0 1px rgba(0,0,0,0.06);
  z-index: 1;
  pointer-events: none;
}

.coin-chip::after {
  content: "";
  position: absolute;
  inset: 12px;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 30%, rgba(255,255,255,0.18), rgba(255,255,255,0.04) 45%, rgba(255,255,255,0) 70%);
  pointer-events: none;
  z-index: 1;
}

.coin-chip:hover {
  transform: translateY(-2px) scale(1.03);
}

.coin-chip:focus {
  outline: none;
}

.coin-chip.is-active,
.coin-chip:active {
  transform: translateY(0) scale(0.98);
}

.coin-chip--1 {
  --chip-main: #1A4F4B;
  --chip-dark: #0d2e2b;
  --chip-light: #2A8C87;
}

.coin-chip--5 {
  --chip-main: #b93d89;
  --chip-dark: #7f285c;
  --chip-light: #de72b1;
}

.coin-chip--10 {
  --chip-main: #1f61bf;
  --chip-dark: #143d78;
  --chip-light: #5b95eb;
}

.coin-chip--50 {
  --chip-main: #2ea6c8;
  --chip-dark: #1d6f87;
  --chip-light: #72d2ee;
}

.coin-chip--100 {
  --chip-main: #cc3535;
  --chip-dark: #822020;
  --chip-light: #f07070;
}

.coin-chip--500 {
  --chip-main: #74a319;
  --chip-dark: #4d6a10;
  --chip-light: #addb49;
  font-size: 15px;
}

@media only screen and (max-width: 991px) {
  .bet-cart-card {
    position: static;
    top: auto;
    margin-top: 16px;
  }

  .bet-slug-nav__list {
    gap: 8px;
    padding: 12px;
  }

  .bet-slug-nav__list > li {
    width: calc(50% - 4px);
  }

  .bet-slug-nav__list > li > a.btn-bet-info {
    display: flex;
    justify-content: center;
    min-height: 44px;
    align-items: center;
    text-align: center;
  }

  .bet-hero-card__name {
    font-size: 21px;
  }

  .coin-chip {
    width: 54px;
    height: 54px;
    min-width: 54px;
    min-height: 54px;
    font-size: 14px;
  }

  .coin-chip--500 {
    font-size: 12px;
  }
}

@media only screen and (max-width: 767px) {
  .bet-page-container {
    padding-left: 8px;
    padding-right: 8px;
  }

  .bet-hero-card__title,
  .bet-section-card > .ibox-title,
  .bet-section-card > .ibox-content,
  .bet-cart-card__title,
  .bet-cart-card__content {
    padding-left: 14px;
    padding-right: 14px;
  }

  .money-chips.bet-money-chips {
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 6px !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 4px;
  }

  .money-chips.bet-money-chips > .coin-chip {
    flex: 0 0 42px !important;
    width: 42px !important;
    height: 42px !important;
    min-width: 42px !important;
    min-height: 42px !important;
  }
}

.bet-number-tile {
  position: relative;
  min-height: 46px;
  border-radius: 16px !important;
  border: 1px solid rgba(42, 110, 107, 0.16) !important;
  box-shadow: 0 10px 18px rgba(26, 79, 75, 0.05);
  font-weight: 800;
  letter-spacing: 0.2px;
  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease,
    border-color 0.18s ease,
    filter 0.18s ease;
  overflow: hidden;
}

.bet-number-tile:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(26, 79, 75, 0.09);
  filter: saturate(1.03);
}

.bet-number-tile:focus,
.bet-number-tile:active {
  outline: none !important;
}

.bet-number-tile::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.03) 48%, rgba(0,0,0,0.03) 100%);
  pointer-events: none;
}

.bet-number-tile.color0,
.bet-number-tile.color1,
.bet-number-tile.color2,
.bet-number-tile.color3,
.bet-number-tile.color4,
.bet-number-tile.color5,
.bet-number-tile.color6,
.bet-number-tile.color7,
.bet-number-tile.color8,
.bet-number-tile.color9 {
  color: #fff !important;
}

.bet-number-tile.color0 {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: rgba(26, 79, 75, 0.22) !important;
}

.bet-number-tile.color1 {
  background: linear-gradient(135deg, #547a2f 0%, #7ba84a 100%) !important;
  border-color: rgba(84, 122, 47, 0.22) !important;
}

.bet-number-tile.color2 {
  background: linear-gradient(135deg, #235E59 0%, #4d96a9 100%) !important;
  border-color: rgba(35, 94, 89, 0.22) !important;
}

.bet-number-tile.color3 {
  background: linear-gradient(135deg, #3f5c9c 0%, #6285cf 100%) !important;
  border-color: rgba(63, 92, 156, 0.22) !important;
}

.bet-number-tile.color4 {
  background: linear-gradient(135deg, #7b4e9f 0%, #a772cf 100%) !important;
  border-color: rgba(123, 78, 159, 0.22) !important;
}

.bet-number-tile.color5 {
  background: linear-gradient(135deg, #9a4b84 0%, #c56fae 100%) !important;
  border-color: rgba(154, 75, 132, 0.22) !important;
}

.bet-number-tile.color6 {
  background: linear-gradient(135deg, #b85a3c 0%, #df8663 100%) !important;
  border-color: rgba(184, 90, 60, 0.22) !important;
}

.bet-number-tile.color7 {
  background: linear-gradient(135deg, #b0792f 0%, #d6a04f 100%) !important;
  border-color: rgba(176, 121, 47, 0.22) !important;
}

.bet-number-tile.color8 {
  background: linear-gradient(135deg, #4f6f7f 0%, #7f9baa 100%) !important;
  border-color: rgba(79, 111, 127, 0.22) !important;
}

.bet-number-tile.color9 {
  background: linear-gradient(135deg, #5f6a72 0%, #87939b 100%) !important;
  border-color: rgba(95, 106, 114, 0.22) !important;
}

.bet-number-tile.active,
.bet-number-tile.selected,
.bet-number-tile.is-active {
  box-shadow:
    0 0 0 3px rgba(255,255,255,0.72),
    0 0 0 6px rgba(26, 79, 75, 0.16),
    0 16px 28px rgba(26, 79, 75, 0.14) !important;
  transform: translateY(-1px) scale(1.01);
}

.bet-grid-row .col-xs-1,
.bet-grid-row .col-sm-1,
.bet-grid-row .col-md-1,
.bet-grid-row .col-lg-1 {
  margin-bottom: 10px;
}

@media only screen and (max-width: 767px) {
  .bet-number-tile {
    min-height: 42px;
    border-radius: 14px !important;
    font-size: 13px !important;
    padding-left: 4px;
    padding-right: 4px;
  }
}

.bet-soft-action-btn {
  border-radius: 999px !important;
  border: 1px solid rgba(42, 110, 107, 0.18) !important;
  background: linear-gradient(180deg, #ffffff 0%, #f2f7f7 100%) !important;
  color: #235E59 !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 18px rgba(26, 79, 75, 0.05);
}

.bet-shoot-shell {
  padding: 4px;
}

.bet-shoot-panel,
.bet-shoot-table-card,
.bet-result-shell {
  padding: 28px 22px 20px;
}

.bet-result-head {
  margin-bottom: 24px;
}

.bet-result-head__title {
  margin: 0 0 8px;
  font-size: 34px;
  line-height: 1.2;
  font-weight: 800;
  color: #1a2e2d;
}

.bet-result-head__subtitle {
  margin: 0 auto;
  max-width: 520px;
  text-align: center;
  font-size: 15px;
  line-height: 1.45;
  font-weight: 700;
  color: #df5f68;
}

.bet-result-row {
  margin-bottom: 10px;
}

.bet-result-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 16px;
  margin-bottom: 16px;
}

.bet-result-grid--two {
  max-width: 740px;
  margin-left: auto;
  margin-right: auto;
}

.bet-result-grid--three {
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
}

.bet-result-grid__item {
  display: flex;
}

.bet-result-grid--two .bet-result-grid__item {
  flex: 1 1 300px;
  max-width: 340px;
}

.bet-result-grid--three .bet-result-grid__item {
  flex: 1 1 240px;
  max-width: 300px;
}

.bet-result-stat-card {
  width: 100%;
  min-height: 156px;
  border-radius: 22px;
  padding: 20px 18px;
  border: 1px solid rgba(42, 110, 107, 0.16);
  background:
    radial-gradient(circle at top left, rgba(42, 110, 107, 0.16), transparent 38%),
    linear-gradient(180deg, #ffffff 0%, #f5fafa 100%);
  box-shadow: 0 14px 28px rgba(26, 79, 75, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.bet-result-stat-card--compact {
  min-height: 138px;
}

.bet-result-stat-card--name {
  min-height: 200px;
}

.bet-result-stat-card h3 {
  margin: 0 0 12px;
  font-size: 15px;
  line-height: 1.45;
  font-weight: 700;
  color: #2a5e5a;
}

.bet-result-stat-card__value,
.bet-result-stat-card h1 {
  margin: 0;
  font-size: 34px;
  line-height: 1.08;
  font-weight: 900;
  color: #1A4F4B;
  letter-spacing: -0.02em;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.bet-result-stat-card__value--name {
  font-size: clamp(32px, 3vw, 46px);
  line-height: 1.1;
}

.bet-result-stat-card__value--mix {
  display: inline-flex;
  align-items: baseline;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0;
}

.bet-result-stat-card__value--mix > span {
  display: inline-block;
}

.bet-result-stat-card .text-navy {
  color: #1f5b82 !important;
}

.bet-result-stat-card .text-info {
  color: #2d7ea8 !important;
}

.bet-result-stat-card .text-danger {
  color: #c0392b !important;
}

.bet-result-stat-card .text-success {
  color: #1A4F4B !important;
}

.bet-table-shell {
  border: 1px solid rgba(42, 110, 107, 0.16);
  border-radius: 20px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(246,250,250,0.96) 100%);
  box-shadow: 0 14px 28px rgba(26, 79, 75, 0.06);
}

.bet-table-shell .el-table {
  background: transparent !important;
  color: #1e2e2d;
}

.bet-table-shell .el-table::before {
  display: none;
}

.bet-table-shell .el-table th.el-table__cell,
.bet-table-shell .el-table th {
  background: linear-gradient(180deg, #f5fafa 0%, #edf5f5 100%) !important;
  color: #1A4F4B !important;
  font-weight: 800;
  border-bottom: 1px solid rgba(42, 110, 107, 0.12) !important;
}

.bet-table-shell .el-table td.el-table__cell,
.bet-table-shell .el-table td,
.bet-table-shell .el-table tr {
  background: transparent !important;
  border-bottom: 1px solid rgba(42, 110, 107, 0.08) !important;
}

.bet-table-shell .el-table tbody tr:hover > td {
  background: rgba(42, 110, 107, 0.06) !important;
}

.bet-table-shell .el-table .warning-row {
  background: rgba(96, 167, 214, 0.14) !important;
}

.bet-table-shell .el-table .success-row {
  background: rgba(214, 104, 104, 0.14) !important;
}

.bet-table-shell .el-pagination {
  padding: 14px 16px 16px;
  background: transparent;
}

.bet-table-shell .el-pager li,
.bet-table-shell .btn-next,
.bet-table-shell .btn-prev {
  border-radius: 10px;
}

@media only screen and (max-width: 991px) {
  .bet-shoot-panel,
  .bet-shoot-table-card,
  .bet-result-shell {
    margin-bottom: 14px;
  }

  .bet-shoot-countdown {
    font-size: 34px;
  }

  .bet-shoot-sum-card__value {
    font-size: 48px;
  }

  .bet-result-head__title {
    font-size: 30px;
  }

  .bet-result-grid--two,
  .bet-result-grid--three {
    max-width: 100%;
  }

  .bet-result-grid--two .bet-result-grid__item,
  .bet-result-grid--three .bet-result-grid__item {
    flex-basis: calc(50% - 8px);
    max-width: calc(50% - 8px);
  }

  .bet-result-stat-card__value,
  .bet-result-stat-card h1 {
    font-size: 30px;
  }

  .bet-result-stat-card__value--name {
    font-size: clamp(28px, 4.5vw, 38px);
  }
}

@media only screen and (max-width: 767px) {
  .bet-shoot-panel,
  .bet-shoot-table-card,
  .bet-result-shell {
    border-radius: 20px;
    padding: 16px 14px;
  }

  .bet-shoot-panel__title {
    font-size: 20px;
  }

  .bet-shoot-countdown {
    font-size: 28px;
  }

  .bet-shoot-sum-card__value {
    font-size: 40px;
  }

  .bet-shoot-input {
    height: 52px !important;
    font-size: 20px !important;
  }

  .bet-primary-action {
    height: 46px;
    font-size: 14px !important;
  }

  .bet-shoot-closed-state {
    font-size: 24px;
  }

  .bet-result-head {
    margin-bottom: 18px;
  }

  .bet-result-head__title {
    font-size: 24px;
  }

  .bet-result-grid {
    gap: 12px;
    margin-bottom: 12px;
  }

  .bet-result-grid--two .bet-result-grid__item,
  .bet-result-grid--three .bet-result-grid__item {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .bet-result-stat-card,
  .bet-result-stat-card--compact,
  .bet-result-stat-card--name {
    min-height: auto;
  }

  .bet-result-stat-card {
    padding: 18px 16px;
  }

  .bet-result-stat-card__value,
  .bet-result-stat-card h1 {
    font-size: 28px;
  }

  .bet-result-stat-card__value--name {
    font-size: 26px;
  }
}

.bet-cart-card {
  position: sticky;
  top: 88px;
}

.bet-cart-card__title {
  position: relative;
  padding: 16px 18px;
  border-bottom: 1px solid rgba(42, 110, 107, 0.14);
  background: linear-gradient(180deg, rgba(249,252,252,0.98) 0%, rgba(241,247,247,0.98) 100%);
}

.bet-cart-card__content {
  padding: 18px;
  background: transparent;
}

.bet-cart-card__content .input-group {
  box-shadow: none;
}

.bet-cart-card__content .form-control {
  height: 44px;
  border-radius: 14px !important;
  border: 1px solid rgba(42, 110, 107, 0.25) !important;
  background: #fbfdfd !important;
  color: #1e2e2d;
  box-shadow: none !important;
}

.bet-cart-card__content .input-group-addon {
  border-radius: 14px 0 0 14px !important;
  border: 1px solid rgba(42, 110, 107, 0.22) !important;
  background: #eef5f5 !important;
  color: #1A4F4B !important;
  font-weight: 700;
}

.bet-cart-card__content .input-group-btn > .btn.btn-default,
.bet-cart-card__content .btn.btn-secondary {
  border: 1px solid rgba(42, 110, 107, 0.18) !important;
  background: linear-gradient(180deg, #ffffff 0%, #eff6f6 100%) !important;
  color: #1A4F4B !important;
  font-weight: 700 !important;
  box-shadow: none !important;
}

.bet-cart-card__content .btn.btn-primary {
  border: 0 !important;
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  box-shadow: 0 12px 24px rgba(26, 79, 75, 0.18);
  font-weight: 800 !important;
}

.bet-cart-card__content .btn.btn-danger {
  border: 0 !important;
  box-shadow: 0 10px 18px rgba(192, 57, 43, 0.16);
  font-weight: 700 !important;
}

.bet-cart-card__content h4 {
  font-size: 14px;
  font-weight: 800;
  color: #1A4F4B;
  padding-bottom: 6px;
  border-bottom: 1px dashed rgba(42, 110, 107, 0.20);
}

.bet-cart-card__content strong {
  color: #1e2e2d;
}

.bet-cart-card .btn-block {
  border-radius: 14px !important;
}

.bet-cart-card .input-group-btn > .btn {
  height: 44px;
}

.bet-cart-card .input-group-btn > .btn.btn-danger {
  border-radius: 0 14px 14px 0 !important;
}

@media only screen and (max-width: 991px) {
  .bet-cart-card {
    position: static;
    top: auto;
    margin-top: 16px;
  }
}

.bet-cart-inline-btn {
  border-radius: 14px !important;
  white-space: nowrap;
}

.bet-slug-nav .navbar-nav,
.bet-slug-nav .navbar-nav > li,
.bet-slug-nav .navbar-nav > li.active,
.bet-slug-nav .navbar-nav > li:hover,
.bet-slug-nav .navbar-nav > li:focus,
.bet-slug-nav .navbar-nav > li:active {
  background: transparent !important;
  box-shadow: none !important;
  border-left: 0 !important;
}

.bet-slug-nav .navbar-nav > li > a,
.bet-slug-nav .navbar-nav > li > a:hover,
.bet-slug-nav .navbar-nav > li > a:focus,
.bet-slug-nav .navbar-nav > li > a:active,
.bet-slug-nav .navbar-nav > li.active > a,
.bet-slug-nav .navbar-nav > li.active > a:hover,
.bet-slug-nav .navbar-nav > li.active > a:focus,
.bet-slug-nav .navbar-nav > li.active > a:active {
  background-image: none !important;
  outline: 0 !important;
  box-shadow: none !important;
  text-decoration: none !important;
}

.bet-slug-nav__list > li > a.btn-bet-info {
  display: block;
  border-radius: 999px !important;
  border: 1px solid #d8872f !important;
  background: linear-gradient(135deg, #ef7a00 0%, #df6400 100%) !important;
  color: #fff !important;
  font-weight: 700;
  -webkit-tap-highlight-color: transparent;
  transition: all 0.2s ease !important;
}

.bet-slug-nav__list > li > a.btn-bet-info:hover,
.bet-slug-nav__list > li > a.btn-bet-info:focus,
.bet-slug-nav__list > li > a.btn-bet-info:active,
.bet-slug-nav__list > li.active > a.btn-bet-info,
.bet-slug-nav__list > li.active > a.btn-bet-info:hover,
.bet-slug-nav__list > li.active > a.btn-bet-info:focus,
.bet-slug-nav__list > li.active > a.btn-bet-info:active {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: transparent !important;
  color: #fff !important;
  box-shadow: 0 12px 24px rgba(26, 79, 75, 0.18) !important;
}

.bet-slug-nav .navbar-default .navbar-nav > .active > a,
.bet-slug-nav .navbar-default .navbar-nav > .active > a:hover,
.bet-slug-nav .navbar-default .navbar-nav > .active > a:focus,
.bet-slug-nav .navbar-default .navbar-nav > li > a:hover,
.bet-slug-nav .navbar-default .navbar-nav > li > a:focus {
  background: transparent !important;
  color: inherit !important;
}

#boxrule,
#boxrule h1,
#boxrule h2,
#boxrule h3,
#boxrule h4,
#boxrule h5,
#boxrule p,
#boxrule span,
#boxrule li,
#boxrule td,
#boxrule th,
#boxrule small,
#boxrule strong,
#cart-item-list,
#cart-item-list h1,
#cart-item-list h2,
#cart-item-list h3,
#cart-item-list h4,
#cart-item-list h5,
#cart-item-list p,
#cart-item-list span,
#cart-item-list label,
#cart-item-list td,
#cart-item-list th,
#cart-item-list small,
#cart-item-list strong {
  color: #1A4F4B !important;
  text-shadow: none !important;
}

#box-number2dtop .btn,
#box-number2ddown .btn,
#boxrunning .btn,
.subtype-group .btn,
.nav-search-permutation .btn,
.nav-search-permutation .btn-default {
  color: #1A4F4B !important;
  text-shadow: none !important;
}

#box-number2dtop .btn *,
#box-number2ddown .btn *,
#boxrunning .btn *,
.subtype-group .btn *,
.nav-search-permutation .btn *,
.nav-search-permutation .btn-default * {
  color: inherit !important;
}

#box-number2dtop .btn.btn-primary,
#box-number2ddown .btn.btn-primary,
#boxrunning .btn.btn-primary,
.subtype-group .btn.btn-primary,
.nav-search-permutation .btn.btn-primary {
  color: #ffffff !important;
}

#box-number2dtop .btn.btn-primary *,
#box-number2ddown .btn.btn-primary *,
#boxrunning .btn.btn-primary *,
.subtype-group .btn.btn-primary *,
.nav-search-permutation .btn.btn-primary * {
  color: #ffffff !important;
}

#boxdown strong {
  display: block !important;
  margin-bottom: 10px !important;
  color: #1A4F4B !important;
  text-align: center !important;
}

#boxdown .btn-group {
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: center !important;
  gap: 6px !important;
  width: 100% !important;
}

#boxdown .btn-group > .btn {
  float: none !important;
  min-width: 38px !important;
  height: 38px !important;
  padding: 0 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
  text-align: center !important;
  border-radius: 10px !important;
  background: linear-gradient(180deg, #ffffff 0%, #f3f8f8 100%) !important;
  border: 1px solid rgba(42, 110, 107, 0.18) !important;
  color: #1A4F4B !important;
  text-shadow: none !important;
  box-shadow: 0 6px 14px rgba(26, 79, 75, 0.05) !important;
}

#boxdown .btn-group > .btn *,
#boxdown .btn-group > .btn.btn-default *,
#boxdown .btn-group > .btn.btn-sm * {
  color: inherit !important;
}

#boxdown .btn-group > .btn.active,
#boxdown .btn-group > .btn.btn-primary,
#boxdown .btn-group > .btn:active {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: transparent !important;
  color: #ffffff !important;
}

#boxdown .btn-group > .btn.active *,
#boxdown .btn-group > .btn.btn-primary *,
#boxdown .btn-group > .btn:active * {
  color: #ffffff !important;
}

#boxdown .column .btn,
#boxdown .column .btn.btn-default,
#boxdown .column .btn.btn-block {
  min-height: 42px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1.1 !important;
  text-align: center !important;
  color: #1A4F4B !important;
  text-shadow: none !important;
}

#boxdown .column .btn *,
#boxdown .column .btn.btn-default * {
  color: inherit !important;
}

.bet-cart-card {
  position: relative !important;
  top: auto !important;
  z-index: 1 !important;
  margin-bottom: 18px !important;
}

#cart-item-list {
  position: relative !important;
}

#boxrule {
  position: relative !important;
  top: auto !important;
  bottom: auto !important;
  left: auto !important;
  right: auto !important;
  transform: none !important;
  clear: both !important;
  margin-top: 18px !important;
  z-index: 1 !important;
}

#boxrule,
#boxrule h1,
#boxrule h2,
#boxrule h3,
#boxrule h4,
#boxrule h5,
#boxrule p,
#boxrule span,
#boxrule label,
#boxrule td,
#boxrule th,
#boxrule small,
#boxrule strong,
#boxrule li,
#boxrule div {
  color: #1A4F4B !important;
  text-shadow: none !important;
}

@media only screen and (max-width: 991px) {
  .money-chips.bet-money-chips > button,
  .money-chips > button,
  .money-chips .c1,
  .money-chips .c5,
  .money-chips .c10,
  .money-chips .c50,
  .money-chips .c100,
  .money-chips .c500 {
    flex: 0 0 54px !important;
    width: 54px !important;
    height: 54px !important;
    min-width: 54px !important;
    min-height: 54px !important;
    max-width: 54px !important;
    max-height: 54px !important;
  }

  #boxdown .btn-group > .btn {
    min-width: 34px !important;
    height: 34px !important;
    padding: 0 8px !important;
  }
}

#boxdown > .row {
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: flex-start !important;
  justify-content: space-between !important;
  gap: 16px !important;
}

#boxdown > .row > .col-md-4 {
  float: none !important;
  width: 33.333333% !important;
  max-width: 33.333333% !important;
  flex: 0 0 33.333333% !important;
}

#boxdown .btn-group {
  display: flex !important;
  flex-wrap: nowrap !important;
  justify-content: center !important;
  gap: 4px !important;
  width: 100% !important;
}

#boxdown .btn-group > .btn {
  min-width: 32px !important;
  width: 32px !important;
  height: 36px !important;
  padding: 0 !important;
  flex: 0 0 32px !important;
  font-size: 16px !important;
}

@media only screen and (max-width: 1199px) {
  #boxdown > .row {
    flex-wrap: wrap !important;
  }

  #boxdown > .row > .col-md-4 {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }

  #boxdown .btn-group {
    flex-wrap: wrap !important;
  }
}

.down-inline-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-top: 16px;
  margin-bottom: 8px;
}

.down-inline-group {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1 0;
  min-width: 0;
}

.down-inline-label {
  width: 56px;
  flex: 0 0 58px;
  text-align: right;
  color: #1A4F4B !important;
}

.down-inline-buttons {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-wrap: nowrap;
}

.down-inline-buttons > .btn {
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  background: linear-gradient(180deg, #ffffff 0%, #f3f8f8 100%) !important;
  border: 1px solid rgba(42, 110, 107, 0.18) !important;
  color: #1A4F4B !important;
  text-shadow: none !important;
}

.down-inline-buttons > .btn.btn-primary,
.down-inline-buttons > .btn.active,
.down-inline-buttons > .btn:active {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: transparent !important;
  color: #ffffff !important;
}

@media only screen and (max-width: 1199px) {
  .down-inline-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .down-inline-group {
    flex-wrap: wrap;
  }
}

@media only screen and (max-width: 767px) {
  .down-inline-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
  }
}

#boxup .btn.btn-primary,
#boxfront .btn.btn-primary,
#boxdown .btn.btn-primary,
#boxrunning .btn.btn-primary,
#boxhilow .btn.btn-primary,
#boxevenodd .btn.btn-primary {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: #1A4F4B !important;
  color: #fff !important;
  box-shadow:
    0 0 0 2px rgba(255,255,255,0.92),
    0 0 0 5px rgba(26, 79, 75, 0.22),
    0 10px 20px rgba(26, 79, 75, 0.18) !important;
  position: relative;
  z-index: 1;
}

#boxup .btn.btn-primary:hover,
#boxfront .btn.btn-primary:hover,
#boxdown .btn.btn-primary:hover,
#boxrunning .btn.btn-primary:hover,
#boxhilow .btn.btn-primary:hover,
#boxevenodd .btn.btn-primary:hover,
#boxup .btn.btn-primary:focus,
#boxfront .btn.btn-primary:focus,
#boxdown .btn.btn-primary:focus,
#boxrunning .btn.btn-primary:focus,
#boxhilow .btn.btn-primary:focus,
#boxevenodd .btn.btn-primary:focus {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: #1A4F4B !important;
  color: #fff !important;
}

#boxup .btn.btn-default,
#boxfront .btn.btn-default,
#boxdown .btn.btn-default,
#boxrunning .btn.btn-default,
#boxhilow .btn.btn-default,
#boxevenodd .btn.btn-default {
  box-shadow: none !important;
}

#boxdown .btn-group > .btn.btn-primary {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: #1A4F4B !important;
  color: #fff !important;
  box-shadow:
    0 0 0 2px rgba(255,255,255,0.92),
    0 0 0 5px rgba(26, 79, 75, 0.20),
    0 8px 16px rgba(26, 79, 75, 0.16) !important;
  position: relative;
  z-index: 2;
}

#boxdown .btn-group > .btn.btn-default {
  color: #111 !important;
}

.subtype-group .btn.btn-primary {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: #1A4F4B !important;
  color: #fff !important;
  box-shadow: 0 10px 18px rgba(26, 79, 75, 0.16) !important;
}

.subtype-group .btn.btn-default {
  color: #111 !important;
}

#boxup .btn.btn-default.color0,
#boxfront .btn.btn-default.color0,
#boxdown .btn.btn-default.color0 {
  background: linear-gradient(135deg, #7abfbc 0%, #5eaaa7 100%) !important;
  border-color: #55a09d !important;
  color: #f8ffff !important;
}

#boxup .btn.btn-default.color1,
#boxfront .btn.btn-default.color1,
#boxdown .btn.btn-default.color1 {
  background: linear-gradient(135deg, #a8c98a 0%, #8db36a 100%) !important;
  border-color: #84ab60 !important;
  color: #fbfff8 !important;
}

#boxup .btn.btn-default.color2,
#boxfront .btn.btn-default.color2,
#boxdown .btn.btn-default.color2 {
  background: linear-gradient(135deg, #8fc2c9 0%, #73aeb7 100%) !important;
  border-color: #6aa5ad !important;
  color: #f8feff !important;
}

#boxup .btn.btn-default.color3,
#boxfront .btn.btn-default.color3,
#boxdown .btn.btn-default.color3 {
  background: linear-gradient(135deg, #99aed8 0%, #7f98c7 100%) !important;
  border-color: #748dbc !important;
  color: #fbfcff !important;
}

#boxup .btn.btn-default.color4,
#boxfront .btn.btn-default.color4,
#boxdown .btn.btn-default.color4 {
  background: linear-gradient(135deg, #b59bcf 0%, #9a80bc 100%) !important;
  border-color: #9075b2 !important;
  color: #fdfaff !important;
}

#boxup .btn.btn-default.color5,
#boxfront .btn.btn-default.color5,
#boxdown .btn.btn-default.color5 {
  background: linear-gradient(135deg, #d2a0bf 0%, #ba82a6 100%) !important;
  border-color: #ae769a !important;
  color: #fffafd !important;
}

#boxup .btn.btn-default.color6,
#boxfront .btn.btn-default.color6,
#boxdown .btn.btn-default.color6 {
  background: linear-gradient(135deg, #d8ab92 0%, #c18e72 100%) !important;
  border-color: #b68367 !important;
  color: #fffaf8 !important;
}

#boxup .btn.btn-default.color7,
#boxfront .btn.btn-default.color7,
#boxdown .btn.btn-default.color7 {
  background: linear-gradient(135deg, #dcc08d 0%, #c6a56c 100%) !important;
  border-color: #bb9b62 !important;
  color: #fffdf8 !important;
}

#boxup .btn.btn-default.color8,
#boxfront .btn.btn-default.color8,
#boxdown .btn.btn-default.color8 {
  background: linear-gradient(135deg, #a9bbc4 0%, #8ea4af 100%) !important;
  border-color: #8499a4 !important;
  color: #fbfdff !important;
}

#boxup .btn.btn-default.color9,
#boxfront .btn.btn-default.color9,
#boxdown .btn.btn-default.color9 {
  background: linear-gradient(135deg, #afb8be 0%, #96a1a8 100%) !important;
  border-color: #8c979e !important;
  color: #fcfdff !important;
}

#boxup .btn.btn-default,
#boxfront .btn.btn-default,
#boxdown .btn.btn-default {
  box-shadow: 0 4px 10px rgba(0,0,0,0.04) !important;
  filter: saturate(0.82) brightness(1.04) !important;
}

#boxdown button.btn.btn-primary,
#boxdown button.btn.btn-primary:hover,
#boxdown button.btn.btn-primary:focus,
#boxdown button.btn.btn-primary:active {
  color: #fff !important;
}

#boxdown button.btn.btn-primary.color0,
#boxdown button.btn.btn-primary.color1,
#boxdown button.btn.btn-primary.color2,
#boxdown button.btn.btn-primary.color3,
#boxdown button.btn.btn-primary.color4,
#boxdown button.btn.btn-primary.color5,
#boxdown button.btn.btn-primary.color6,
#boxdown button.btn.btn-primary.color7,
#boxdown button.btn.btn-primary.color8,
#boxdown button.btn.btn-primary.color9 {
  color: #fff !important;
}

#boxdown button.btn.btn-primary span,
#boxdown button.btn.btn-primary strong {
  color: #fff !important;
}

#box-rules,
#box-rules p,
#box-rules li,
#box-rules span,
#box-rules div,
#box-rules small,
#box-rules strong,
#box-rules b,
#box-rules label,
#box-rules td,
#box-rules th {
  color: #1f2225 !important;
}

#box-rules .text-danger,
#box-rules .text-danger * {
  color: #ed5565 !important;
}

#box-rules .text-success,
#box-rules .text-success * {
  color: #1ab394 !important;
}

#box-rules .text-info,
#box-rules .text-info * {
  color: #23c6c8 !important;
}

#box-rules .text-primary,
#box-rules .text-primary * {
  color: #1c84c6 !important;
}

#box-rules .text-warning,
#box-rules .text-warning * {
  color: #f8ac59 !important;
}

#box-rules .text-muted,
#box-rules .text-muted * {
  color: #888 !important;
}

#modal-confirm-checkout .modal-dialog,
#modal-checkout-success .modal-dialog {
  width: 720px;
  max-width: calc(100vw - 24px);
  margin: 28px auto;
}

#modal-confirm-checkout .modal-content,
#modal-checkout-success .modal-content {
  overflow: hidden;
  border: 1px solid rgba(42, 110, 107, 0.16);
  border-radius: 28px;
  background:
    radial-gradient(circle at top left, rgba(42, 110, 107, 0.12), transparent 34%),
    linear-gradient(180deg, #ffffff 0%, #f4fafa 100%);
  box-shadow: 0 28px 64px rgba(26, 79, 75, 0.16);
  color: #1e2e2d !important;
}

#modal-confirm-checkout .modal-header,
#modal-checkout-success .modal-header {
  padding: 22px 24px 18px !important;
  border-bottom: 1px solid rgba(42, 110, 107, 0.14);
  background:
    radial-gradient(circle at top left, rgba(42, 110, 107, 0.18), transparent 34%),
    linear-gradient(180deg, #f8fcfc 0%, #eef6f6 100%);
  text-align: center;
}

#modal-confirm-checkout .modal-title,
#modal-checkout-success .modal-title {
  font-size: 24px;
  line-height: 1.4;
  font-weight: 800;
  color: #1A4F4B !important;
  margin-top: 0;
  margin-bottom: 6px;
}

#modal-confirm-checkout .font-bold,
#modal-checkout-success .font-bold,
#modal-confirm-checkout small,
#modal-checkout-success small {
  color: #2a6e6b !important;
  font-size: 13px;
  letter-spacing: 0.02em;
}

#modal-confirm-checkout .close,
#modal-checkout-success .close {
  opacity: 1;
  color: #235E59;
  text-shadow: none;
}

#modal-confirm-checkout .close:hover,
#modal-checkout-success .close:hover {
  color: #1A4F4B;
}

#modal-confirm-checkout .modal-body,
#modal-checkout-success .modal-body {
  padding: 20px 22px !important;
  background: transparent;
  color: #1e2e2d !important;
}

#modal-confirm-checkout .modal-body h3,
#modal-confirm-checkout .modal-body h4,
#modal-checkout-success .modal-body h3,
#modal-checkout-success .modal-body h4,
#modal-confirm-checkout .modal-body strong,
#modal-checkout-success .modal-body strong {
  color: #1A4F4B !important;
}

#modal-confirm-checkout .p-sm,
#modal-checkout-success .p-sm {
  padding: 18px 20px !important;
}

#modal-confirm-checkout .border-top,
#modal-checkout-success .border-top,
#modal-confirm-checkout .border-bottom,
#modal-checkout-success .border-bottom {
  border-color: rgba(42, 110, 107, 0.12) !important;
}

#modal-confirm-checkout hr,
#modal-checkout-success hr {
  border-top: 1px dashed rgba(42, 110, 107, 0.16);
}

#modal-confirm-checkout .row,
#modal-checkout-success .row {
  margin-left: -8px;
  margin-right: -8px;
}

#modal-confirm-checkout .row > [class*="col-"],
#modal-checkout-success .row > [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

#modal-confirm-checkout .btn,
#modal-checkout-success .btn {
  height: 52px;
  border-radius: 16px !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s ease;
}

#modal-confirm-checkout .btn.btn-primary,
#modal-checkout-success .btn.btn-primary {
  border: 0 !important;
  color: #fff !important;
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  box-shadow: 0 14px 28px rgba(26, 79, 75, 0.20);
}

#modal-confirm-checkout .btn.btn-primary:hover,
#modal-checkout-success .btn.btn-primary:hover,
#modal-confirm-checkout .btn.btn-primary:focus,
#modal-checkout-success .btn.btn-primary:focus {
  color: #fff !important;
  background: linear-gradient(135deg, #1A4F4B 0%, #235E59 100%) !important;
}

#modal-confirm-checkout .btn.btn-danger,
#modal-confirm-checkout .btn.btn-default,
#modal-checkout-success .btn.btn-danger,
#modal-checkout-success .btn.btn-default {
  border: 1px solid rgba(42, 110, 107, 0.16) !important;
  color: #235E59 !important;
  background: linear-gradient(180deg, #ffffff 0%, #eef5f5 100%) !important;
  box-shadow: none !important;
}

#modal-confirm-checkout .btn.btn-danger:hover,
#modal-confirm-checkout .btn.btn-default:hover,
#modal-checkout-success .btn.btn-danger:hover,
#modal-checkout-success .btn.btn-default:hover {
  color: #1A4F4B !important;
  background: linear-gradient(180deg, #fdfefd 0%, #e9f1f1 100%) !important;
}

#modal-confirm-checkout .col-xs-12.m-t-sm {
  padding-left: 18px;
  padding-right: 18px;
}

#modal-confirm-checkout .col-xs-12.m-t-sm h4 {
  font-size: 14px;
  font-weight: 800;
}

#modal-confirm-checkout .col-xs-12.m-t-sm .row {
  padding: 8px 0;
  border-bottom: 1px dashed rgba(42, 110, 107, 0.10);
}

#modal-confirm-checkout .col-xs-12.m-t-sm .row:last-child {
  border-bottom: 0;
}

#modal-confirm-checkout .text-right,
#modal-checkout-success .text-right {
  color: #1A4F4B;
}

#modal-checkout-success .modal-header h1 {
  width: 92px;
  height: 92px;
  margin: 0 auto 14px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%);
  box-shadow: 0 16px 34px rgba(26, 79, 75, 0.22);
}

#modal-checkout-success .modal-header h1 .fa {
  font-size: 42px !important;
  color: #ffffff !important;
}

#modal-checkout-success .text-navy {
  color: #ffffff !important;
}

#modal-checkout-success .modal-body + .p-sm,
#modal-checkout-success .p-sm.text-center {
  background: rgba(255, 255, 255, 0.50);
}

#modal-checkout-success .col-xs-12.m-t-sm {
  padding-left: 18px;
  padding-right: 18px;
}

#modal-checkout-success .col-xs-12.m-t-sm h4 {
  font-size: 14px;
  font-weight: 800;
  color: #1A4F4B !important;
}

#modal-checkout-success .col-xs-12.m-t-sm > div {
  font-size: 14px;
  color: #1e2e2d !important;
}

#modal-checkout-success [style*="color: blue"] {
  color: #1A4F4B !important;
  font-weight: 800;
}

#modal-checkout-success .text-danger {
  color: #c0392b !important;
  font-weight: 800;
}

#modal-checkout-success .col-xs-12.m-t-sm:last-of-type {
  margin-top: 18px !important;
  padding-top: 8px;
}

@media only screen and (max-width: 767px) {
  #modal-confirm-checkout .modal-dialog,
  #modal-checkout-success .modal-dialog {
    width: auto;
    max-width: calc(100vw - 16px);
    margin: 12px auto;
  }

  #modal-confirm-checkout .modal-content,
  #modal-checkout-success .modal-content {
    border-radius: 22px;
  }

  #modal-confirm-checkout .modal-header,
  #modal-checkout-success .modal-header {
    padding: 18px 16px 16px !important;
  }

  #modal-confirm-checkout .modal-title,
  #modal-checkout-success .modal-title {
    font-size: 20px;
  }

  #modal-confirm-checkout .btn,
  #modal-checkout-success .btn {
    height: 48px;
    font-size: 14px !important;
  }

  #modal-checkout-success .modal-header h1 {
    width: 78px;
    height: 78px;
    margin-bottom: 12px;
  }

  #modal-checkout-success .modal-header h1 .fa {
    font-size: 34px !important;
  }
}

.bet-shoot-panel {
  border: 1px solid rgba(42, 110, 107, 0.18);
  border-radius: 24px;
  background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(246,250,250,0.96) 100%);
  box-shadow: 0 18px 40px rgba(26, 79, 75, 0.08);
  padding: 22px 20px;
  min-height: 100%;
}

.bet-shoot-panel__header {
  margin-bottom: 18px;
}

.bet-shoot-panel__eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #235E59 !important;
  margin-bottom: 6px;
  display: block;
}

.bet-shoot-panel__title {
  margin: 0 auto;
  max-width: 420px;
  text-align: center;
  font-size: 20px;
  line-height: 1.35;
  font-weight: 800;
  color: #c84f5a !important;
  display: block;
}

@media only screen and (max-width: 767px) {
  .bet-shoot-panel__title {
    max-width: 100%;
    font-size: 14px;
    line-height: 1.4;
    padding: 0 6px;
  }
}

.bet-shoot-countdown {
  display: block;
  text-align: center;
  font-size: 42px;
  line-height: 1.1;
  font-weight: 800;
  color: #c0392b !important;
  margin-bottom: 18px;
}

.bet-shoot-sum-card {
  display: block !important;
  border-radius: 22px;
  padding: 16px 18px;
  margin-bottom: 18px;
  text-align: center;
  background:
    radial-gradient(circle at top left, rgba(42, 110, 107, 0.20), transparent 35%),
    linear-gradient(135deg, #eef7f7 0%, #f8fcfc 100%);
  border: 1px solid rgba(42, 110, 107, 0.16);
  box-shadow: 0 10px 20px rgba(26, 79, 75, 0.05);
}

.bet-shoot-sum-card__label {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #235E59 !important;
  margin-bottom: 6px;
}

.bet-shoot-sum-card__value {
  display: block;
  font-size: 56px;
  line-height: 1;
  font-weight: 900;
  color: #1A4F4B !important;
}

@media only screen and (max-width: 767px) {
  .bet-shoot-panel {
    border-radius: 20px;
    padding: 16px 14px;
  }

  .bet-shoot-panel__title {
    font-size: 20px;
  }

  .bet-shoot-countdown {
    font-size: 28px;
  }

  .bet-shoot-sum-card__value {
    font-size: 40px;
  }
}
</style>
